<template>
  <div id="writeArticles" class="vx-row" style="padding-left: 20px">
    <div class="vx-col w-full md:w-2/3" style="min-width: 630px;">
      <div class="flex flex-wrap items-center flex-grow">
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer" icon="MenuIcon" style="height: 20px; margin-right: 10px;" @click.stop="showSidebar"></feather-icon>
        <ul class="flex flex-wrap items-center">
          <li>
            <vs-radio @change="photoCheck('off')" color="success" v-model="sendData.type" vs-value="1">일반기사</vs-radio>
          </li>
          <li>
            <vs-radio @change="photoCheck('on')" color="danger" v-model="sendData.type" vs-value="9">포토기사</vs-radio>
          </li>
        </ul>
      </div>

      <div id="toolbar2" slot="toolbar">
        <span class="wa-field-label">홈페이지 제목 |</span>
        <button class="ql-circled" style="width: 55px;">원문자</button>
        <button class="ql-italic">Italic</button>
        <button class="ql-underline">Underline</button>
        <span class="ql-color">
          <select class="ql-color" title="Colour"></select>
        </span>
        <button id="custom-button-2-4" style="width: 50px" @click="customButtonClick($refs.quillEditor_b_sbj.quill, sendData.byline)">매크로</button>
        <select class="ql-customSpecial" style="line-height: 1.8em;">
          <option value="※"/>
          <option value="▲"/>
          <option value="△"/>
          <option value="ⓒ"/>
          <option value="→"/>
          <option value="…"/>
          <option value="·"/>
          <option value="㈜"/>

          <option value="￠"/>
          <option value="￡"/>
          <option value="￥"/>
          <option value="￦"/>
          <option value="₠"/>
          <option value="₡"/>
          <option value="₢"/>
          <option value="₣"/>

          <option value="☚"/>
          <option value="☛"/>
          <option value="☜"/>
          <option value="☝"/>
          <option value="☞"/>
          <option value="☟"/>
          <option value="☢"/>
          <option value="♺"/>

          <option value="♩"/>
          <option value="♪"/>
          <option value="♫"/>
          <option value="♬"/>
          <option value="♭"/>
          <option value="♮"/>
          <option value="♯"/>
          <option value="♰"/>
          
          <option value="☼"/>
          <option value="☀"/>
          <option value="☽"/>
          <option value="☾"/>
          <option value="☁"/>
          <option value="☂"/>
          <option value="☃"/>
          <option value="☄"/>

          <option value="↑"/>
          <option value="↓"/>
          <option value="“"/>
          <option value="”"/>
          <option value="‘"/>
          <option value="’"/>
        </select>
      </div>
      <local-quill-editor v-model="sendData.mainTitle"
                    ref="quillEditor_b_sbj"
                    :options="editorOption2"
                    @change="onEditorChange($event)">
      </local-quill-editor>
      
      <div id="toolbar3" slot="toolbar" v-if="sendData.type != '9'">
        <span class="wa-field-label">부 제 |</span>
        <button class="ql-circled" style="width: 55px;">원문자</button>
        <button class="ql-italic">Italic</button>
        <button class="ql-underline">Underline</button>
        <span class="ql-color">
          <select class="ql-color" title="Colour"></select>
        </span>
        <button id="custom-button-3-4" style="width: 50px" @click="customButtonClick($refs.quillEditor_s_sbj.quill, sendData.byline)">매크로</button>
        <select class="ql-customSpecial" style="line-height: 1.8em;">
          <option value="※"/>
          <option value="▲"/>
          <option value="△"/>
          <option value="ⓒ"/>
          <option value="→"/>
          <option value="…"/>
          <option value="·"/>
          <option value="㈜"/>

          <option value="￠"/>
          <option value="￡"/>
          <option value="￥"/>
          <option value="￦"/>
          <option value="₠"/>
          <option value="₡"/>
          <option value="₢"/>
          <option value="₣"/>

          <option value="☚"/>
          <option value="☛"/>
          <option value="☜"/>
          <option value="☝"/>
          <option value="☞"/>
          <option value="☟"/>
          <option value="☢"/>
          <option value="♺"/>

          <option value="♩"/>
          <option value="♪"/>
          <option value="♫"/>
          <option value="♬"/>
          <option value="♭"/>
          <option value="♮"/>
          <option value="♯"/>
          <option value="♰"/>
          
          <option value="☼"/>
          <option value="☀"/>
          <option value="☽"/>
          <option value="☾"/>
          <option value="☁"/>
          <option value="☂"/>
          <option value="☃"/>
          <option value="☄"/>

          <option value="↑"/>
          <option value="↓"/>
          <option value="“"/>
          <option value="”"/>
          <option value="‘"/>
          <option value="’"/>
        </select>
      </div>
      <local-quill-editor v-model="sendData.subTitle" v-if="sendData.type != '9'"
                    ref="quillEditor_s_sbj"
                    :options="editorOption3"
                    @change="onEditorChange($event)">
      </local-quill-editor>
      <h4 id='textcount'> 글자수 {{ textcount }} / 원고지 {{ papers }}매</h4>      
      <div id="toolbar" slot="toolbar">
        <button class="ql-artSubhead" style="width: 80px; border-left: 3px solid;">내부부제</button>
        <button class="ql-artSection" style="width: 80px; border-left: 2px solid;">내부단락</button>
        <button class="ql-artBox1" style="width: 55px; border-left: 1px solid #A6A6A6;">박스1</button>
        <button class="ql-artBox2" style="width: 55px; border-left: 2px solid #A6A6A6;">박스2</button>
        <button class="ql-artBubble" style="width: 65px; border-left: 3px solid #D6D6D6;">말풍선</button>
        <button class="ql-highlight" style="width: 65px; border-left: 3px solid #D6D6D6; line-height: 1; font-size: 14px; font-weight: 500; color: #0000FF;">형광펜</button>

        <button class="ql-circled" style="width: 55px;">원문자</button>
        <span class="ql-align">
          <select class="ql-align" title="Align"></select>
        </span>
        <button class="ql-bold">Bold</button>
        <button class="ql-italic">Italic</button>
        <button class="ql-underline">Underline</button>
        <button class="ql-link">Link</button>
        <button class="ql-list" value="ordered">List</button>
        <button class="ql-list" value="bullet">List</button>
        <span class="ql-color">
          <select class="ql-color" title="Colour"></select>
        </span>
        <button class="ql-image">Image</button>
        <button class="ql-video">Video</button>
        <button id="custom-button-1-4" style="width: 50px" @click="customButtonClick($refs.quillEditor_descr.quill, sendData.byline)">매크로</button>
        <select class="ql-customSpecial" style="line-height: 1.8em;">
          <option value="※"/>
          <option value="▲"/>
          <option value="△"/>
          <option value="ⓒ"/>
          <option value="→"/>
          <option value="…"/>
          <option value="·"/>
          <option value="㈜"/>

          <option value="￠"/>
          <option value="￡"/>
          <option value="￥"/>
          <option value="￦"/>
          <option value="₠"/>
          <option value="₡"/>
          <option value="₢"/>
          <option value="₣"/>

          <option value="☚"/>
          <option value="☛"/>
          <option value="☜"/>
          <option value="☝"/>
          <option value="☞"/>
          <option value="☟"/>
          <option value="☢"/>
          <option value="♺"/>

          <option value="♩"/>
          <option value="♪"/>
          <option value="♫"/>
          <option value="♬"/>
          <option value="♭"/>
          <option value="♮"/>
          <option value="♯"/>
          <option value="♰"/>

          <option value="☼"/>
          <option value="☀"/>
          <option value="☽"/>
          <option value="☾"/>
          <option value="☁"/>
          <option value="☂"/>
          <option value="☃"/>
          <option value="☄"/>

          <option value="↑"/>
          <option value="↓"/>
          <option value="“"/>
          <option value="”"/>
          <option value="‘"/>
          <option value="’"/>
        </select>
        <!-- <button id="custom-button-1-4" style="width: 65px;" @click="customButtonClick2()">관련기사</button> -->
        <button style="width: 85px; line-height: 1.6; font-size: 14px; font-weight: 500; color: #0000FF;" @click="photoPickerOpen = true">포토 검색</button>
        <button type="button" style="width: 85px; font-weight: 700;" @click="$refs.bodyFind.open()">본문 찾기</button>
        
      </div>
      <article-body-find v-if="bodyFindReady" ref="bodyFind" :get-editor="getBodyEditor" />
      <local-quill-editor
                    v-model="content"
                    class="quillEditor_descr"
                    ref="quillEditor_descr"
                    :options="editorOption"
                    @change="onEditorChange($event)"
                    @ready="onEditorReady"
                    style="height: calc(100vh - 310px)"
                    >
      </local-quill-editor>
      <div class="news-rel"  v-html="news_rel">
      </div>
      
    </div>
    <!-- <div class="vx-card" style="width: 680px; padding: 5px; margin-left:15px; font-size: 16px; font-family: '맑은고딕','Malgun Gothic'; text-align: justify; line-height: 25px;" v-html="contentView"></div> -->
    <div class="vx-col w-full md:w-1/4">
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>작성자: </p>
        </div>
        <div v-if="activeUserInfo.level >= 8" class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label" placeholder="작성자 선택" label="nickname" v-model="tmpWriter"
            :options="writerOptions" @input="setWriter" :clearable="false"/>
        </div>
        <div v-if="activeUserInfo.level < 8" class="vx-col" style="width: 210px; padding: 10px">
          <div>{{ activeUserInfo.name }}</div>
        </div>
      </div>
      <div v-if="activeUserInfo.level >= 8">
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>기타 작성자: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label" multiple placeholder="기타 작성자 선택" label="nickname" v-model="tmpWriter2"
             @input="setWriter2" :options="otherWriterOptions"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>기사 상태: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label" placeholder="기사 상태 선택" label="name" v-model="sendData.state"
            :options="states" :clearable="false"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>엠바고: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px;">
          <date-picker v-model="sendData.d_pass" type="datetime" :clearable="false"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>카테고리1: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label vs-category" multiple placeholder="카테고리1 선택" label="name" v-model="sendData.category1"
             @input="setCategory1" :options="categories1"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>카테고리1-2: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label vs-category" multiple placeholder="카테고리1-2 선택" label="name" v-model="sendData.category1_2"
             @input="setCategory1_2" :disabled="category1_2Disable" :options="categories1_2_view"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>카테고리2: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select ref="category2Select" class="vs-con-input-label vs-category" multiple placeholder="카테고리2 선택" label="name" v-model="sendData.category2"
             @input="setCategory2" :options="categories2"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>카테고리2-2: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label vs-category" multiple placeholder="카테고리2-2 선택" label="name" v-model="sendData.category2_2"
             @input="setCategory2_2" :disabled="category2_2Disable" :options="categories2_2_view"/>
        </div>
      </div>
      <div v-if="!reviewDisable">
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>리뷰 평가: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label" placeholder="평가 점수" label="text" v-model="sendData.review_rate"
            :options="reviewOption"/>
        </div>
      </div>
      <div v-if="!siteDisable">
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 4px">
          <p >현장기사: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <div style="height: 27px;"><toggle-button color="rgba(115, 103, 240, 1)" v-model="sendData.site" style="top: 2px"/></div>
        </div>
      </div>
      <!-- ── 포토셋 / 포토타입 (2026-09-29 제거) ────────────────────────────────
        🔴 **중앙신문에 없는 기능이라 통째로 뺐다.**
           `v-if` 조건이 `category1` 에 **id 10** 이 있는지였는데, 데일리안에서는
           그게 '포토'였지만 중앙신문 section 에서 **id 10 은 '오피니언'**이다
           (포토는 id 11). 그래서 기자가 오피니언을 고르면 오른쪽에 포토셋 칸이
           튀어나왔다 — 2026-09-29 "특정 경우에 포토셋이 나타난다" 지적.
        🔴 조건을 11로 고치지 않고 **없앤 이유**: 포토셋은 동작하지 않는다.
           `joongangtv_cms/writeArticles.js` 의 `makePhotoSet` 은
           "photo_set table not available" 주석과 함께 입력값을 그대로 돌려주는
           스텁이고, DB 에 `photo_set` 테이블 자체가 없다(실측: `%photo%` 로
           잡히는 건 `article_photo` 하나뿐). 목록도 항상 비어 있다.
           포토타입 라디오의 값(12·13·…·29)도 데일리안 카테고리 번호라 여기선 뜻이 없다.
        ⚠ `sendData.photoSet` / `photoType` / `photoType2` 필드는 **그대로 둔다** —
          저장 payload 모양이 바뀌면 서버 쿼리가 깨진다. 화면에서만 뺐다.
        포토기사 여부는 맨 위 '일반기사 / 포토기사' 라디오(`sendData.type`)가 정한다.
      ───────────────────────────────────────────────────────────────────── -->
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>시리즈: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select class="vs-con-input-label" placeholder="시리즈 선택" label="name" v-model="sendData.series"
            @input="setSeries" :options="seriesArray"/>
          <!-- <v-select class="vs-con-input-label vs-category" multiple placeholder="시리즈 선택" label="name" v-model="sendData.series"
            :options="seriesArray" :closeOnSelect="false"/> -->
          <!-- <vs-select
            :success="sendData.series != '' && sendData.series != null"
            :warning="sendData.series == '' || sendData.series == null"
            placeholder="시리즈 선택" label="" v-model="sendData.series"
            style="height: 39px;"
            >
            <vs-select-item :key="index" :value="item.code" :text="item.name" v-for="(item,index) in seriesArray"/>
          </vs-select> -->
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>byline: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <vs-input class="inputx" placeholder="byline" v-model="sendData.byline"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>email: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <vs-input class="inputx" placeholder="email" @change="changeEmail" v-model="sendData.email"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 7px">
          <p>태그 :</p><p style="font-size: 12px;">(네이버 키워드)</p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <v-select ref="tagSelect" class="vs-con-input-label vs-tag" @option:created="tagFocusFlg = true;" @search:blur="setSelected" taggable multiple v-model="sendData.tag"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 5px">
          <p>썸네일 설정: </p>
        </div>
        <div class="vx-col flex-wrap" style="width: 210px; padding: 0px">
          <toggle-button color="rgba(115, 103, 240, 1)" v-model="thumbnailFlg" style="top: 2px"/>
          <p v-if="thumbnailFlg"> 썸네일 위치: </p>
          <ul class="flex flex-wrap items-center" v-if="thumbnailFlg">
            <li><vs-radio v-model="thumbnailOption" vs-value="crop">자르기</vs-radio></li>
            <li style="margin-right: 50px;"><vs-radio v-model="thumbnailOption" vs-value="fit">전체포함</vs-radio></li>
            <!-- <li><vs-slider v-model="thumbnail2" style="min-width: 190px;" text-fixed=% /> </li> -->
            <li><vs-slider v-model="thumbnail" style="min-width: 190px;" text-fixed=% /> </li>
            <p>이미지 번호: </p>
            <li><input type="text" style="width: 20px;" v-model="thumbnailImageNum"></li>
          </ul>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 5px">
        </div>
        <div class="vx-col flex-wrap" style="width: 210px; padding: 0px">
          <toggle-button color="rgba(115, 103, 240, 1)" v-model="watermarkFlg" @change="watermarkToggle" style="top: 2px"/>
          <p>워터마크: </p>
          <div v-if="watermarkFlg">
            <ul class="flex flex-wrap items-center">
              <li><vs-radio v-model="sendData.watermark" vs-value="northwest">좌상단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="north">상단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="northeast">우상단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="southwest">좌하단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="south">하단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="southeast">우하단</vs-radio>
              </li>
              <li><vs-radio v-model="sendData.watermark" vs-value="center">중앙</vs-radio>
              </li>
            </ul>
            <p v-if="watermarkFlg">이미지 번호: </p>
            <input type="text" style="width: 20px;" v-model="watermarkImageNum"> *숫자입력은 해당이미지만, 0은 모든이미지에 적용
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 5px">
          <p>포털전송: </p>
        </div>
        <div class="vx-col" style="width: 210px; padding: 0px">
          <toggle-button color="rgba(115, 103, 240, 1)" v-model="portalFlg"/>
        </div>
      </div>
      <div>
        <div class="vx-col" style="width: 100px; padding: 0px; margin-top: 9px">
          <p>전송할 포털: </p>
        </div>
        <div class="vx-col">
          <v-select class="vs-con-input-label vs-category" multiple placeholder="포털 선택" label="name" 
          v-model="sendData.portalAction" :closeOnSelect="false" :options="portals"/>
        </div>
      </div>

      <div style="margin-top: 20px">
        <vs-button :disabled="previewDisable" color="success" type="filled" v-on:click="dataToArticle(function(){})" >미리보기 ({{sendButtonText}})</vs-button> 
      </div>
      <div style="margin-top: 20px; padding: 0px;">
        <textarea v-model="lockHistory" style="width: 100%; height: 200px; text-align: right;" />
      </div>

    </div>
          

    <!-- Start: 미리보기 팝업 -->
    <div id="div-with-loading" class="news-detail-form vs-con-loading__container">
      <vs-popup ref="popup-newsDetail" classContent="popup-newsDetail" title="미리보기" :active.sync="newsDetailModalActive">
        <div>
          <div class="news-detail">
            <div v-html="contentPreview"></div>
          </div>
          <div class="flex" style="justify-content: space-around; margin-bottom: 20px; padding: 20px 0; border-bottom: 1px solid #ccc; border-top: 1px solid #ccc;">
            <!-- 미리보기: 
            <vs-radio color="success" v-model="previewType" vs-value="iPhone1">아이폰1(375)</vs-radio>
            <vs-radio color="success" v-model="previewType" vs-value="iPhone2">아이폰2(414)</vs-radio>
            <vs-radio color="success" v-model="previewType" vs-value="android1">안드로이드1(360)</vs-radio>
            <vs-radio color="success" v-model="previewType" vs-value="android2">안드로이드2(420)</vs-radio>
            <vs-radio color="success" v-model="previewType" vs-value="pc">PC</vs-radio> -->
            
            <vs-button color="blue" size="small" @click="previewType = 'iPhone1'" style="width: 25%" >iOS 미리보기</vs-button>
            <vs-button color="danger" size="small" @click="previewType = 'android1'" style="width: 25%" >Android 미리보기</vs-button>
            <vs-button color="grey" size="small" @click="previewType = 'pc'" style="width: 25%" >PC 미리보기</vs-button>
          </div>
          <div :class="previewType == 'pc' ? 'news-detail' : 
            previewType == 'iPhone1' ? 'newsDetailMobile iPhone1' : 
            previewType == 'iPhone2' ? 'newsDetailMobile iPhone2' :
            previewType == 'android1' ? 'newsDetailMobile android1' :
            previewType == 'android2' ? 'newsDetailMobile android2' :
            previewType == 'android3' ? 'newsDetailMobile android3' : ''">
            <div v-html="contentView"></div>
          </div>
        </div>
        <div style="position: sticky;max-height: 140px;bottom: -1rem;background: white;">
          <div class='news-rel'><h3>주요 뉴스</h3>
            <ul>
              <li v-for="(newsRel, idx) in sendData.rel" :key="idx">
                <a :href="'https://www.jasm.co.kr/news/view/' + newsRel.id" target="_blank" v-html="newsRel.b_sbj"></a>
              </li>
            </ul>
          </div>
          <vs-button style="float: right" id='sendButton' :disabled="sendButtonDisable" color="primary" type="filled" v-on:click="sendDataToServer()" >{{sendButtonText}}</vs-button>
          <div class="flex" style="margin-top: 20px; justify-content: space-around;">
            <div><vs-radio v-model="relNewsListType" vs-value="newRanking" @change="changeRelType">자동배치</vs-radio></div>
            <div><vs-radio v-model="relNewsListType" vs-value="ranking" @change="changeRelType">많이본기사</vs-radio></div>
            <div><vs-radio v-model="relNewsListType" vs-value="search" @change="changeRelType">뉴스검색</vs-radio></div>
            <!-- <div><vs-radio v-model="relNewsListType" vs-value="recent" @change="changeRelType">최신기사</vs-radio></div>
            <div><vs-radio v-model="relNewsListType" vs-value="ranking" @change="changeRelType">많이본기사</vs-radio></div> -->
          </div>
          <div v-if="relNewsListType == 'search'" class="flex">
            <v-select style="width: 100px" placeholder="카테고리" label="name" :reduce="name => name.code" v-model="tmpCategory1"
              :options="categories1"/>
            <vs-input class="inputx" placeholder="기사 검색" v-model="searchText" @keyup.enter="getNewsList()" style="display: inline-block;"/>
            <vs-button color="primary" type="border" v-on:click="getNewsList()" >검색</vs-button>
            <vs-button color="danger" type="border" v-on:click="swipeRelList()" >비우기</vs-button>
          </div>
          <div>
            <div v-for="(newsRel, idx) in newsRelListSearch[relNewsListType]" :key="idx">
              <md-checkbox @change="newsRelChange(newsRel, idx)" :value="newsRel" v-model="sendData.rel" >
                <b v-if="sendData.rel.find(e => e.id == newsRel.id)" v-html="newsRel.id + ' | ' + newsRel.d_pass + ' | ' + newsRel.b_sbj.replace(/<\/?strong>/g, '')"></b>
                <span v-else v-html="newsRel.id + ' | ' + newsRel.d_pass + ' | ' + newsRel.b_sbj.replace(/<\/?strong>/g, '')"></span>
              </md-checkbox>
            </div>
          </div>
          <div style="width: 100%; border: 1px solid black;"></div>
          <div>
            <div v-for="(newsRel, idx) in newsRelList" :key="idx">
              <md-checkbox @change="newsRelChange(newsRel, idx)" :value="newsRel" v-model="sendData.rel" >
                <b v-if="sendData.rel.find(e => e.id == newsRel.id)" v-html="newsRel.id + ' | ' + newsRel.d_pass + ' | ' + newsRel.b_sbj.replace(/<\/?strong>/g, '')"></b>
                <span v-else v-html="newsRel.id + ' | ' + newsRel.d_pass + ' | ' + newsRel.b_sbj.replace(/<\/?strong>/g, '')"></span>
              </md-checkbox>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
    <!-- End: 미리보기 팝업 -->
    <!-- Start: 관련기사 팝업 -->
    <div id="div-with-loading" class="news-detail-form vs-con-loading__container">
      <vs-popup ref="popup-relNews" classContent="popup-newsDetail" title="관련기사" :active.sync="relNewsModalActive">
        <div style="height: 500px;bottom: -1rem;background: white;">
          <div class="flex">
            <v-select style="width: 100px" placeholder="카테고리" label="name" :reduce="name => name.code" v-model="tmpCategory1"
              :options="categories1"/>
            <vs-input class="inputx" placeholder="기사 검색" v-model="searchText" @keyup.enter="getNewsList2()" style="display: inline-block;"/>
            <vs-button color="primary" type="border" v-on:click="getNewsList2()" >검색</vs-button>
            <vs-button color="primary" type="filled" v-on:click="setInnerNewsRel()" >관련기사 넣기</vs-button>
          </div>
          <div>
            <div v-for="(newsRel, idx) in relNewsSearch" :key="idx">
              <md-checkbox :value="newsRel" v-model="relNewsList" >
                <span v-html="newsRel.id + ' | ' + newsRel.d_pass + ' | ' + newsRel.b_sbj.replace(/<\/?strong>/g, '')"></span>
              </md-checkbox>
            </div>
          </div>
        </div>
      </vs-popup>
    </div>
    <!-- End: 관련기사 팝업 -->
    <vs-popup title="뉴스AI 이미지 생성" :active.sync="showNewsAIModal" class="newsai-modal" style="min-width: 600px;">
      <div>
        <label>이미지 비율 선택</label>
        <v-select
          v-model="selectedAspectRatio"
          :options="[
            { text: '정방형', value: 'square' },
            { text: '세로형', value: 'portrait' },
            { text: '가로형', value: 'landscape' }
          ]"
          label="text"
        ></v-select>

        <label style="margin-top: 10px;">스타일 선택</label>
        <div style="display: flex; overflow-x: auto; gap: 10px; margin-top: 10px;">
          <div v-for="style in imageStyles" :key="style.key" @click="selectedStyle = style.key"
            :style="{ border: selectedStyle === style.key ? '2px solid red' : '1px solid gray', cursor: 'pointer', textAlign: 'center', padding: '4px' }">
            <img :src="style.img" style="height: 80px;">
            <div style="font-size: 12px; margin-top: 4px;">{{ style.label }}</div>
          </div>
        </div>

        <vs-button color="primary" @click="generateNewsAIImage" style="margin-top: 20px;">이미지 생성</vs-button>
      </div>
    </vs-popup>
      
    <!-- 제목/부제목 생성 팝업 -->
    <vs-popup title="AI 제목 추천" :active.sync="showTitlePopup" style="min-width: 600px;">
      <div v-if="loadingTitle" class="text-center p-4">제목 생성 중...</div>
      <div v-else>
        <vs-radio style="display: flex;" v-for="(title, idx) in titleCandidates" :key="idx" v-model="selectedTitle" :vs-value="title">
          {{ title }}
        </vs-radio>
        <div class="flex justify-end mt-4">
          <vs-button color="primary" @click="applyTitle">적용</vs-button>
          <vs-button @click="showTitlePopup = false">취소</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="AI 부제목 추천" :active.sync="showSubtitlePopup" style="min-width: 600px;">
      <div v-if="loadingSubtitle" class="text-center p-4">부제목 생성 중...</div>
      <div v-else>
        <vs-checkbox v-for="(subtitle, idx) in subtitleCandidates" :key="idx" v-model="selectedSubtitles" :vs-value="subtitle">
          {{ subtitle }}
        </vs-checkbox>
        <div class="flex justify-end mt-4">
          <vs-button color="primary" @click="applySubtitles">적용</vs-button>
          <vs-button @click="showSubtitlePopup = false">취소</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="AI 키워드 추천" :active.sync="showKeywordPopup" style="min-width: 600px;">
      <div v-if="loadingKeyword" class="text-center p-4">키워드 생성 중...</div>
      <div v-else>
        <vs-checkbox v-for="(keyword, idx) in keywordCandidates" :key="idx" v-model="selectedKeywords" :vs-value="keyword">
          {{ keyword }}
        </vs-checkbox>
        <div class="flex justify-end mt-4">
          <vs-button color="primary" @click="applyKeywords">적용</vs-button>
          <vs-button @click="showKeywordPopup = false">취소</vs-button>
        </div>
      </div>
    </vs-popup>
    <photo-picker-modal
      v-model="photoPickerOpen"
      :multiple="true"
      @confirm="onPhotosPicked"
    />


  </div>

</template>

<script>
import PhotoPickerModal from './components/PhotoPickerModal.vue'
import { imageUrl, thumbnailUrl } from '@/utils/imageUrl'
import { spaceArticleParagraphs } from '@/utils/paragraphSpacing'

// 닫는 블록 태그와 <br> 뒤에 붙은 공백/개행. Quill 이 이걸 빈 문단으로 바꾼다.
// 이관 기사는 문단 구분이 두 가지다 — </p>CRLF CRLF<p> 와 <br />CRLF<br />CRLF.
// 둘 다 HTML 에서는 공백이 접혀 렌더링이 같으므로 걷어내도 표시가 바뀌지 않는다.
const BLOCK_GAP_RE = /(<\/(?:p|div|figure|figcaption|h[1-6]|ul|ol|li|blockquote|table|tr|td)>|<br\s*\/?>)\s+(?=<)/gi;

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
// vue-quill-editor@3.0.6 는 2019년 이후 방치된 퀼 1.x 전용 패키지라 걷어냈다(2026-09-26).
// 같은 동작의 로컬 래퍼를 쓴다 — components/QuillEditor.vue.
import QuillEditor from '../components/QuillEditor.vue'
import ArticleBodyFind from '../components/ArticleBodyFind.vue'
import Quill from 'quill'
import { installPasteFilter, WORD_ALLOW, TITLE_ALLOW } from '../utils/pasteFilter'
import { toCircled, toPlain, isCircled } from '../utils/circledText'
import { safeBack, backTo } from '../router'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

class NoUploader {}
Quill.register({ 'modules/uploader': NoUploader }, true);

// import { ImageDrop } from 'quill-image-drop-module'
// Quill.register('modules/imageDrop', ImageDrop)
// 🔴 quill-image-resize-module 은 **퀼 1 전용 개인 포크**였다
//    (git+github.com/dkstjs2/quill-image-resize-module). 정렬 콜백
//    `setOnChangedListener` 를 쓰려고 누군가 직접 고친 것이다.
//    quill-resize-module 은 left/center/right/full 툴바가 **표준으로 들어 있고**
//    onChangeSize 콜백도 있어서 그 커스터마이즈가 필요 없어졌다.
// 🔴 **ESM 빌드(dist/resize.esm.js)를 쓰면 안 된다.** 그 파일은 자체 webpack
//    런타임을 담고 있는데, 하필 변수 이름이 `var __webpack_require__ = {}` 라
//    **우리 webpack 이 주입하는 식별자와 충돌한다.** 결과는 모듈 평가 시점의
//    `TypeError: Cannot read properties of undefined (reading 'd')` 이고,
//    기사작성 라우트가 통째로 못 열린다.
//    CJS/UMD 빌드에는 그 선언이 없고 `__esModule` 인터롭도 들어 있다.
//    package.json 의 `module` 필드 때문에 webpack 이 ESM 을 먼저 고르므로
//    경로를 **명시**한다.
import QuillResize from 'quill-resize-module/dist/resize.js'
// 🔴 **스타일시트를 같이 들여와야 한다.** 이게 없으면 모듈은 정상으로 도는데
//    오버레이/핸들이 `position:absolute` 도 크기도 없어 화면에 안 잡힌다 —
//    "본문 사진 늘리기/줄이기가 안 됨"(2026-09-29)의 나머지 절반이었다.
//    (앞 절반은 vue.config.js 의 ProvidePlugin 이 퀼을 두 벌 물려 준 것.)
import 'quill-resize-module/dist/resize.css'
Quill.register('modules/resize', QuillResize)

const Parchment = Quill.import('parchment');

// 🔴 퀼 2(parchment 3)에서 `Parchment.Attributor.Class` 경로가 사라지고
//    `Parchment.ClassAttributor` 가 됐다. 두 버전 다 되게 고른다.
const ClassAttributor = Parchment.ClassAttributor || Parchment.Attributor.Class;
const HighlightClass = new ClassAttributor(
  'highlight',      // Delta attributes 키
  'highlight',      // 실제 DOM class
  { scope: Parchment.Scope.INLINE }
);
Quill.register(HighlightClass, true);

// bold 토글 시 highlight까지 함께 관리
function toggleBoldWithHighlight(quill) {
  const range = quill.getSelection(true);
  if (!range) return;

  const cur = quill.getFormat(range);
  const nextBold = !cur.bold;

  // Bold 토글
  quill.format('bold', nextBold);

  // Bold를 끌 때 highlight도 자동 오프
  if (!nextBold) {
    quill.format('highlight', false);
  }
}

// const Delta = Quill.import('delta')
// const Parchment = Quill.import('parchment')

// // Attributor를 올바르게 import
// const Attributor = Quill.import('parchment/attributor/attributor')
// const ClassAttributor = Quill.import('parchment/attributor/class')
// const StyleAttributor = Quill.import('parchment/attributor/style')


// ── 본문 특수 블록 (2026-09-27) ────────────────────────────────────────────
// 🔴 예전에는 퀼 **기본 태그를 빌려 썼다** — 내부부제=blockquote, 내부단락=code-block,
//    박스1·2=header 1·2, 말풍선=header 3. 그래서 세 가지 문제가 있었다.
//      1. 진짜 인용·소제목을 쓸 수 없다(태그가 이미 다른 뜻으로 점유돼 있다).
//      2. 저장된 HTML 이 <h1>·<pre> 라 **웹에는 그 모양이 안 나온다**. 포털로 보낼 때만
//         서버가 정규식으로 인라인 스타일 <div> 를 만들어 냈다.
//      3. 그 정규식들이 **퀼이 만드는 태그 모양**에 통째로 기대고 있어, 퀼 버전을
//         올리면 같이 깨진다.
//    데일리안이 naverBlue/naverGreen 에 쓴 방식(blots/inline + className)을 그대로
//    블록에 적용해 **클래스로 지정**한다. 퀼 1·2 양쪽에서 같은 API 다.
//
// 🔴 기존 기사 호환은 문제가 되지 않는다. 2026-09-27 기준 96,548건 중
//    <blockquote> 1 · <pre> 1 · <h3> 1 · <h1>/<h2>/highlight/<s> 는 0건이었다.
const Block = Quill.import('blots/block');

function defineBlock(blotName, className) {
  const B = class extends Block {};
  B.blotName = blotName;
  B.tagName = 'div';
  B.className = className;
  Quill.register(B, true);
  return B;
}

defineBlock('artSubhead', 'art-subhead');   // 내부부제
defineBlock('artSection', 'art-section');   // 내부단락
defineBlock('artBox1',    'art-box1');      // 박스1
defineBlock('artBox2',    'art-box2');      // 박스2
defineBlock('artBubble',  'art-bubble');    // 말풍선


// 고른 글자를 원문자로 바꾼다(이미 원문자면 되돌린다).
// 🔴 **Delta 로 바꿔 끼운다.** getText + insertText 로 하면 굵게·링크 같은 서식이
//    통째로 날아간다. op 단위로 글자만 갈아 끼우면 서식이 그대로 남는다.
function circleSelection(quill) {
  const range = quill.getSelection(true);
  if (!range || !range.length) return;

  const Delta = Quill.import('delta');
  const picked = quill.getContents(range.index, range.length);
  const back = isCircled(quill.getText(range.index, range.length));

  let changed = false;
  const ops = (picked.ops || []).map(function (op) {
    if (typeof op.insert !== 'string') return op;          // 이미지·동영상은 건드리지 않는다
    const next = back ? toPlain(op.insert) : toCircled(op.insert);
    if (next !== op.insert) changed = true;
    return op.attributes ? { insert: next, attributes: op.attributes } : { insert: next };
  });
  if (!changed) return;

  quill.updateContents(
    new Delta().retain(range.index).delete(range.length).concat(new Delta(ops)), 'user');
  // 되돌릴 때 ⑩~⑳ 은 두 글자가 되므로 길이를 다시 센다.
  const len = ops.reduce(function (n, op) {
    return n + (typeof op.insert === 'string' ? op.insert.length : 1);
  }, 0);
  quill.setSelection(range.index, len, 'silent');
}

// 특수 블록은 서로 배타적이다. 하나를 켜면 나머지를 끈다.
const ART_BLOCKS = ['artSubhead', 'artSection', 'artBox1', 'artBox2', 'artBubble'];
function toggleArtBlock(quill, name) {
  const cur = quill.getFormat();
  const on = !cur[name];
  ART_BLOCKS.forEach(function(n) { if (n !== name && cur[n]) quill.format(n, false); });
  quill.format(name, on);
}

const Container = Quill.import('blots/container')

// 커스텀 블록 정의
class RelatedSection extends Container {
  static create() {
    const node = super.create()
    node.classList.add('related-articles-wrapper')
    return node
  }
}

RelatedSection.blotName = 'related-section'
RelatedSection.tagName = 'div'
RelatedSection.className = 'related-articles-wrapper'

// 블럿 등록
Quill.register(RelatedSection)

// 카테고리1 의 '전체' — **실제 섹션이다**(2026-09-28, `section.code = 'S1N17'`).
// 『중앙신문_CMS_수정안_260922』 6번: "[전체] 카테고리 생성. 단, [전체] 선택시
// 카1-1에서는 선택하지 않고 카테고리2로 자동으로 넘어감."
//
// 🔴 예전에는 `code:'__all__'` 인 **화면 전용 값**이었고 저장 직전 걷어 냈다.
//    그래서 article_section 에 아무것도 안 남아 다시 열면 카테고리1 이 빈 칸이 됐고,
//    기자가 이미 고른 것을 또 골라야 했다. 지금은 그냥 저장된다.
// 🔴 **id 를 박지 않는다.** 로그인 응답으로 받는 목록에서 이름으로 찾는다 —
//    section.id 는 환경마다 다르고, id 를 박는 것이 데일리안 잔재의 원인이었다.
// 🔴 포털 송고와는 무관하다. `lib/portalCategory.js` 의 PORTAL_IGNORED_SECTIONS 가
//    매핑에서 뺀다(송고를 막는 EXCLUDED_SECTIONS 와 다르다).
const ALL_CATEGORY1_NAME = '전체'
function isAllCategory1(c) { return !!(c && c.name === ALL_CATEGORY1_NAME) }

export default {
  // 🔴 **화살표 함수로 두면 안 된다.** Vue 는 `data.call(vm, vm)` 으로 부르는데
  //    화살표는 `this` 를 다시 묶을 수 없어 모듈 스코프의 `this`(= ESM 이라 undefined)를
  //    그대로 쓴다. 그래서 이 안에서 정의한 화살표 콜백의 `this` 도 undefined 였고
  //    `resize.onChangeSize` 가 `Cannot read properties of undefined (reading
  //    '_nudgeEditor')` 로 터졌다 — 그 예외가 리사이즈 모듈의 `handleMouseup` 을
  //    중간에 끊어 **마우스를 떼도 리스너가 안 떨어졌다**(사진이 커서를 계속 따라옴).
  //    ⚠ 아래 퀼 툴바 핸들러들은 `function () {}` 라 퀼이 자기 `this`(툴바 모듈)를
  //      묶어 준다. 그건 그대로 둘 것 — 화살표로 바꾸면 `this.quill` 이 깨진다.
  data() { return ({
    bodyFindReady: false,
    form: {
      actives: {
        category1: false,
        category1_2: false,
        category2: false,
        category2_2: false
      },
      data: {
        category1: {
          categories: [],
          toString: "카테고리1 선택"
        },
        category1_2: {
          categories: [],
          toString: "카테고리1-2 선택"
        },
        category2: {
          categories: [],
          toString: "카테고리2 선택"
        },
        category2_2: {
          categories: [],
          toString: "카테고리2-2 선택"
        }
      }
    },
    sendData:{
      id: '',
      writer: '',
      mno: '33252',
      mno2: '',
      another_writer: '',
      email: '',
      text: '',
      summary: '',
      Images: [],
      mainTitle: '',
      portalTitle: '',
      subTitle: '', 
      state: {'code': ''}, 
      site: false,
      type: '1',
      watermark: '',
      thumbnail: '',
      category1: [],
      category1_2: [],
      category2: [],
      category2_2: [],
      series: {'code': ''},
      review_rate: {'rate': ''},
      byline: '',
      d_pass: '',
      g_money: 0,
      s_money: 0,
      name: '',
      tailname: '',
      tag: [],
      titleTags: [],
      rel: [],
      portalAction: [],
      out_site: '',
      photoType: "1",
      photoType2: "0",
      photoSet: null,
      newPhotoSetName: '',
      sns: {},
    },
    previewType: 'android1',
    portalFlg: true,
    watermarkFlg: false,
    watermarkImageNum: 0,
    thumbnailFlg: false,
    thumbnailOption: 'crop',
    thumbnailImageNum: 1,
    thumbnail: 20,
    thumbnail2: [0,100],
    photoData: [],
    pastState: '9',
    lockHistory: '',
    searchText: '',
    newsRelList: [],
    newsRelListSearch: {'search':[], 'recent': [], 'ranking': [], 'newRanking': []},
    relNewsSearch: [],
    relNewsList: [],
    tmpCategory1: [],
    tmpCategory2: [],
    tmpWriter: {},
    tmpWriter2: [],
    writer: [],
    types: [],
    states: [],
    portals: [],
    // 🔴 '전체' 는 **실제 섹션이 아니다**(section 테이블에 없다). 카테고리1 을 지정하지
    //    않고 카테고리2 로 바로 가기 위한 **표시용 값**이다.
    //    『중앙신문_CMS_수정안_260922』 6번: "[전체] 카테고리 생성. 단, [전체] 선택시
    //    카1-1에서는 선택하지 않고 카테고리2로 자동으로 넘어감."
    //    2026-09-28 부터 **실제 섹션(S1N17)** 이라 그대로 저장된다.
    categories1: [],
    categories1_ok: false,
    categories1_2: [],
    categories1_2_view: [],
    category1_2Disable: true,
    categories2: [],
    categories2_2: [],
    categories2_2_view: [],
    category2_2Disable: true,
    seriesArray: [],
    photoSetArray: [],
    lastArticleTime: moment().add(-1, 'day'),
    snsKeyword: ['온라인 커뮤니티', '해외 커뮤니티', '보배드림', '디시인사이드', '네이트 판', '블라인드'],
    forceCategoryList: [{keyword: '박민영 사내 이사', category: '연예'}],
    sendButtonDisable: true,
    sendButtonText: '기사 저장',
    previewDisable: true,
    textcount: 0,
    papers:0,    
    content: '',
    contentView: '',
    contentPreview: '',
    news_rel: '',
    tmp_rel: [],
    relNewsListType: 'ranking',
    siteDisable: true,
    reviewDisable: true,
    tooltipDisable: false,
    tagFocusFlg: false,
    reviewOption: [{rate: 5, text: '★★★★★'},
                   {rate: 4.5, text: '★★★★☆'},
                   {rate: 4, text: '★★★★'},
                   {rate: 3.5, text: '★★★☆'},
                   {rate: 3, text: '★★★'},
                   {rate: 2.5, text: '★★☆'},
                   {rate: 2, text: '★★'},
                   {rate: 1.5, text: '★☆'},
                   {rate: 1, text: '★'},
                   {rate: 0.5, text: '☆'}],
    editorOption: {
      modules: {
        // toolbar: '#toolbar',//[['bold', 'italic', 'underline'], ['blockquote'], [{ 'list': 'ordered'}, { 'list': 'bullet' }], [{ 'color': [] }], ['link', 'image', 'video']],
        toolbar: {
          container: '#toolbar',
          // container:[
          //   ['bold', 'italic', 'underline'], [{ 'list': 'ordered'}, { 'list': 'bullet' }], [{ 'color': [] }], ['link', 'image', 'video'],
          //   [{'customMacro': '매크로'}], [{'customSpecial': ['ㅁ', 'ㅇ', 'ㅎ']}]
          // ],
          handlers: {
            // 원문자 — 고른 글자를 ①Ⓐⓐ㉠㉮ 로 바꾼다. 이미 원문자면 되돌린다.
            // 🔴 서식이 아니라 **글자 자체**를 바꾸는 것이라 quill.format 이 아니다.
            "circled": function () { circleSelection(this.quill); },
            "customSpecial": function (value) { 
              if (value || value == '') {
                console.log(value, this)
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, value);
                this.quill.setSelection(cursorPosition + value.length);
              }
            },
            // 2) 형광펜 버튼: bold를 보장하고 highlight 클래스를 토글
            highlight: function () {
              const quill = this.quill;
              const range = quill.getSelection(true);
              if (!range) return;

              const cur = quill.getFormat(range);
              const willTurnOn = !cur.highlight;

              // 켤 때는 bold도 함께 켠다 (없으면 <strong> 생성됨)
              if (willTurnOn && !cur.bold) {
                quill.format('bold', true);
              }
              quill.format('highlight', willTurnOn);
            },
            // ✅ Bold 버튼 커스터마이즈: 끌 때 highlight도 끔
            bold: function () {
              toggleBoldWithHighlight(this.quill);
            },
            // 본문 특수 블록 — 서로 배타적이라 전용 토글을 쓴다.
            // (등록만 해도 퀼 툴바가 자동 토글하지만, 그러면 둘을 동시에 켤 수 있다.)
            artSubhead: function () { toggleArtBlock(this.quill, 'artSubhead'); },
            artSection: function () { toggleArtBlock(this.quill, 'artSection'); },
            artBox1:    function () { toggleArtBlock(this.quill, 'artBox1'); },
            artBox2:    function () { toggleArtBlock(this.quill, 'artBox2'); },
            artBubble:  function () { toggleArtBlock(this.quill, 'artBubble'); }
            // "customMacro": function (value) { 
            //   if (value) {
            //     console.log(value, this)
            //     const cursorPosition = this.quill.getSelection().index;
            //     this.quill.insertText(cursorPosition, value);
            //     this.quill.setSelection(cursorPosition + value.length);
            //   }
            // }
          }
        },
        clipboard: true,
        // imageDrop: true,
        resize: {
            modules: [ 'Resize', 'DisplaySize', 'Toolbar' ],
            tools: [ 'left', 'center', 'right', 'full' ],
            // 크기·정렬이 바뀌면 모델에 반영되도록 한 번 흔들어 준다.
            // 옛 포크의 setOnChangedListener 가 하던 일과 같다.
            // 🔴 **여기서 예외가 나가면 안 된다.** 모듈의 handleMouseup 은
            //    `onChangeSize` 를 부른 *뒤에* document 의 mousemove/mouseup
            //    리스너를 뗀다. 중간에 던지면 리스너가 그대로 남아 마우스를
            //    떼도 사진이 커서를 따라 계속 늘었다 줄었다 한다(2026-09-29).
            onChangeSize: () => {
                try { this._nudgeEditor(); }
                catch (e) { console.warn('[resize] onChangeSize', e); }
            },
        },
      },
      // 🔴 'clipboard' 는 포맷이 아니라 **모듈**이다. 퀼 2 가
      //    `Cannot register "clipboard" specified in "formats" config` 를 찍는다.
      //    본문 렌더에는 영향이 없었지만(실측) 잘못 들어간 값이라 뺐다.
      formats: [
        'bold', 'highlight',
        'italic', 'underline', 'strike',
        'blockquote', 'code-block',
        'header', 'list', 'align',
        'link', 'color', 'background',
        'image', 'video',
        // 본문 특수 블록(클래스 지정형)
        'artSubhead', 'artSection', 'artBox1', 'artBox2', 'artBubble'
      ],
      theme: 'snow',
      placeholder: '내용을 입력하세요.'
    },
    editorOption2: {
      modules: {
        toolbar: {
          container: '#toolbar2',
          handlers: {
            // 원문자 — 고른 글자를 ①Ⓐⓐ㉠㉮ 로 바꾼다. 이미 원문자면 되돌린다.
            // 🔴 서식이 아니라 **글자 자체**를 바꾸는 것이라 quill.format 이 아니다.
            "circled": function () { circleSelection(this.quill); },
            "customSpecial": function (value) { 
              if (value) {
                console.log(value, this)
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, value);
                this.quill.setSelection(cursorPosition + value.length);
              }
            },
          }
        },
      },
      theme: 'snow',
      placeholder: '내용을 입력하세요.'
    },
    editorOption3: {
      modules: {
        toolbar: {
          container: '#toolbar3',
          handlers: {
            // 원문자 — 고른 글자를 ①Ⓐⓐ㉠㉮ 로 바꾼다. 이미 원문자면 되돌린다.
            // 🔴 서식이 아니라 **글자 자체**를 바꾸는 것이라 quill.format 이 아니다.
            "circled": function () { circleSelection(this.quill); },
            "customSpecial": function (value) { 
              if (value) {
                console.log(value, this)
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, value);
                this.quill.setSelection(cursorPosition + value.length);
              }
            },
          }
        },
      },
      theme: 'snow',
      placeholder: '내용을 입력하세요.'
    },
    editorOption4: {
      modules: {
        toolbar: {
          container: '#toolbar4',
          handlers: {
            // 원문자 — 고른 글자를 ①Ⓐⓐ㉠㉮ 로 바꾼다. 이미 원문자면 되돌린다.
            // 🔴 서식이 아니라 **글자 자체**를 바꾸는 것이라 quill.format 이 아니다.
            "circled": function () { circleSelection(this.quill); },
            "customSpecial": function (value) { 
              if (value) {
                console.log(value, this)
                const cursorPosition = this.quill.getSelection().index;
                this.quill.insertText(cursorPosition, value);
                this.quill.setSelection(cursorPosition + value.length);
              }
            },
          }
        },
      },
      theme: 'snow',
      placeholder: '내용을 입력하세요.'
    },
    prevRoute: '',
    initImage: false,
    timeFlg: false,
    autoSaveFlg: false,
    // 세션 만료 팝업 무한루프 차단용 플래그 (2026-09-25).
    //   authRedirecting — 401 로 로그인 페이지로 튕기는 중. 이탈 가드가 저장을 다시 묻지 않게 한다.
    //   leaving         — 이미 저장/이탈 처리가 돌고 있음. 두 번째 이탈 요청을 막는다.
    authRedirecting: false,
    leaving: false,
    // 임시저장 기준선(불러온 직후 지문)과 용량경고 1회 플래그
    draftBaseline: '',
    draftWarned: false,
    draftTimer: null,
    draftBoot: null,
    draftOnUnload: null,
    autoSaved: false,
    lockFlg: true,
    newsDetailModalActive: false,
    relNewsModalActive: false,
    // 뉴스AI 이미지
    showNewsAIModal: false,
    selectedAspectRatio: {text:'가로형', value: 'landscape'}, 
    selectedStyle: 'digital-art-1',
    imageStyles: [
      { key: 'digital-art-3', img: 'https://newsimage.videostew.com/digital-art-3.png', label: '실루엣아트' },
      { key: 'digital-art-1', img: 'https://newsimage.videostew.com/digital-art-1.png', label: '삽화' },
      { key: 'photographic', img: 'https://newsimage.videostew.com/photographic.png', label: '포토그래피' },
      { key: 'digital-art-2', img: 'https://newsimage.videostew.com/digital-art-2.png', label: '디지털아트' },
      { key: 'vector', img: 'https://newsimage.videostew.com/vector.png', label: '벡터 일러스트' },
      { key: 'anime', img: 'https://newsimage.videostew.com/anime.png', label: '2D 애니메이션' },
      { key: 'lowpoly', img: 'https://newsimage.videostew.com/lowpoly.png', label: '폴리곤' },
      { key: 'craft-clay', img: 'https://newsimage.videostew.com/craft-clay.png', label: '클레이' },
      { key: '3d-model', img: 'https://newsimage.videostew.com/3d-model.png', label: '3D 모델' },
      { key: 'line-art', img: 'https://newsimage.videostew.com/line-art.png', label: '라인아트' },
      { key: 'pixel-art', img: 'https://newsimage.videostew.com/pixel-art.png', label: '픽셀아트' },
    ],
    // 제목 생성
    showTitlePopup: false,
    titleCandidates: [],
    selectedTitle: '',
    loadingTitle: false,
    // 부제목 생성
    showSubtitlePopup: false,
    subtitleCandidates: [],
    selectedSubtitles: [],
    loadingSubtitle: false,
    // 키워드 생성
    showKeywordPopup: false,
    keywordCandidates: [],
    selectedKeywords: [],
    loadingKeyword: false,
    // 포토검색
    photoPickerOpen: false,
    insertLockedUntil: 0,  // ms
  }); },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // console.log(from)
      vm.prevRoute = from
    })
  },
  beforeRouteLeave (to, from, next) {
    // 🔴 **모든 분기에서 next() 가 정확히 한 번 불려야 한다.** 예전에는
    //    dataToArticle 의 `if(!data)` 안에서만 불러서, 필수항목이 빠지면
    //    내비게이션이 영영 보류된 채 화면이 잠겼다.

    // 401 로 로그인 페이지로 튕기는 중이거나 목적지가 로그인이면 묻지 않고 보낸다.
    // 이게 없으면 handleUnauthorized 의 push 가 이 가드를 깨우고, 가드가 다시
    // 저장을 시도해 401 을 낳는 상호 재진입(팝업 무한루프)이 된다.
    const goingToLogin = to && typeof to.path === 'string' && to.path.indexOf('/pages/login') === 0;
    if(this.authRedirecting || goingToLogin){
      this.newsDetailModalActive = false;
      this.releaseLock();
      return next();
    }
    // 이미 저장/이탈 처리가 돌고 있으면 막는다. 통과시키면 진행 중이던 저장을 잃는다.
    if(this.leaving) return next(false);

    let answered = false;
    const done = (ok) => { if(answered) return; answered = true; this.leaving = false; next(ok); };

    try {
      if(this.autoSaveFlg && confirm('기사를 저장하시겠습니까?')){
        this.leaving = true;
        this.autoSaved = true;
        // 저장이 끝나지 않아도 화면이 잠기지 않게 상한을 둔다.
        const bail = setTimeout(() => done(true), 8000);
        this.dataToArticle((data, _x, error) => {
          clearTimeout(bail);
          // 401 이면 저장이 아니라 재로그인이다. 가드는 통과시키고
          // handleUnauthorized 가 로그인으로 보낸다.
          if(error && this.isAuthError(error)){ this.handleUnauthorized(); return done(true); }
          if(!data){
            this.newsDetailModalActive = false;
            this.sendDataToServer();
            setTimeout(() => done(true), 100);
          }else{
            // 검증 실패(필수항목 누락 등) — 작성창에 머문다.
            done(false);
          }
        });
      }else{
        this.newsDetailModalActive = false;
        setTimeout(() => done(true), 100);
      }
    } catch (e) {
      // 동기 예외로 next() 를 놓치면 화면이 영영 잠긴다.
      console.log('beforeRouteLeave error:', e);
      done(true);
    }
    this.releaseLock();
  },
  watch: {
    '$route.query': function() {
      console.log(this.$route.query);
      this.newsDetailModalActive = false;
      this.created();
    },
    'sendData.state': function() {
      if(this.sendData.state == this.states.find(e => e.code == '1')) this.sendButtonText = '기사 전송'
      else  this.sendButtonText = '기사 저장'
    },
    'relNewsModalActive': function() {
      this.relNewsSearch = [];
      this.relNewsList = [];
    }

  },
  components: {
    ArticleBodyFind,
    LocalQuillEditor: QuillEditor,
    DatePicker,
    PhotoPickerModal,
  },
  methods: {
    getBodyEditor() { return this.$refs.quillEditor_descr.quill; },
    // ── 세션 만료 처리 (2026-09-25) ──────────────────────────────────
    // 401 판정과 로그인 이동을 한 곳으로 모은다. 전에는 catch 5곳이 제각기
    // `alert` + `$router.push` 를 했고, 그 push 가 beforeRouteLeave 를 깨워
    // 가드가 다시 저장을 시도 → 또 401 … 로 팝업이 무한히 떴다.
    isAuthError(error) {
      const res = error && error.response;
      if(res && res.status === 401) return true;
      // 서버가 토큰 없음을 400 으로 준다(login.js). 이것도 재로그인 대상이다.
      if(res && res.status === 400 && res.data && res.data.msg === 'Token 없음') return true;
      // 🔴 응답 객체가 **없을 때만** 문자열 폴백을 쓴다. 500 응답 본문에 '401' 이
      //    섞여도 참이 되던 기존 판정(errorText.includes('401'))의 재발을 막는다.
      //    axios 는 error.status 가 항상 undefined 다 — error.response.status 를 본다.
      if(!res && String(error).includes('401')) return true;
      return false;
    },

    // ── 작성 내용 임시저장 (2026-09-25) ────────────────────────────────
    // 세션이 끊기거나 브라우저가 죽어도 작성 중이던 기사를 잃지 않게 하는 안전장치.
    // localStorage 에만 쓴다 — 서버 저장(sendDataToServer)과는 별개다.
    draftKey() {
      const mno = (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.id) || 'anon';
      // 기자별·기사별로 분리한다. 신규 작성은 'new'.
      return 'wa_draft:' + mno + ':' + (this.sendData.id || 'new');
    },

    // 저장할 값만 추린다.
    // 🔴 text / summary / images 처럼 **본문에서 파생되는 필드는 뺀다.** 복원에
    //    불필요하고 용량만 키운다(localStorage 는 보통 5MB 다).
    draftPayload() {
      const d = this.sendData;
      const pick = ['id','mainTitle','portalTitle','subTitle','byline','email','tag','titleTags',
                    'category1','category1_2','category2','category2_2','series','state','d_pass',
                    'rel','out_site','portalAction','review_rate','photoType','photoType2'];
      const out = {};
      pick.forEach(k => { if(d[k] !== undefined) out[k] = d[k]; });
      out.__content = this.content;
      return out;
    },

    // 변경 여부 판정용 지문. 이것이 기준선과 같으면 저장하지 않는다.
    draftFingerprint() {
      try { return JSON.stringify(this.draftPayload()); } catch(e){ return ''; }
    },

    saveDraft(reason) {
      try {
        const fp = this.draftFingerprint();
        // 🔴 **변경이 없으면 저장하지 않는다.** 안 그러면 그냥 열어본 기사마다
        //    복원 확인창이 떠서 소음이 된다.
        if(!fp || fp === this.draftBaseline) return false;
        const body = JSON.stringify({ at: Date.now(), reason: reason || '', data: JSON.parse(fp) });
        localStorage.setItem(this.draftKey(), body);
        return true;
      } catch(e) {
        // 용량 초과 — 본문만이라도 남긴다.
        try {
          localStorage.setItem(this.draftKey(), JSON.stringify({
            at: Date.now(), reason: 'quota', data: { id: this.sendData.id, __content: this.content } }));
          return true;
        } catch(e2) {
          // 🔴 조용히 실패하면 기자는 보호받는 줄 알고 계속 쓴다. 반드시 알린다.
          if(!this.draftWarned){
            this.draftWarned = true;
            alert('임시저장 공간이 부족합니다. 작성 중인 기사를 수동으로 저장해주세요.');
          }
          return false;
        }
      }
    },

    // 🔴 기준선도 함께 갱신한다. 안 그러면 서버 저장 성공 직후 beforeDestroy 의
    //    저장이 방금 지운 임시저장을 되살린다.
    clearDraft() {
      try { localStorage.removeItem(this.draftKey()); } catch(e){}
      this.draftBaseline = this.draftFingerprint();
    },

    // 7일 지난 임시저장 정리 + 복원 제안
    initDraft() {
      const now = Date.now();
      const WEEK = 7 * 24 * 60 * 60 * 1000;
      try {
        for(let i = localStorage.length - 1; i >= 0; i--){
          const k = localStorage.key(i);
          if(!k || k.indexOf('wa_draft:') !== 0) continue;
          try {
            const v = JSON.parse(localStorage.getItem(k));
            if(!v || !v.at || now - v.at > WEEK) localStorage.removeItem(k);
          } catch(e){ localStorage.removeItem(k); }
        }
        const raw = localStorage.getItem(this.draftKey());
        if(!raw) return;
        const saved = JSON.parse(raw);
        if(!saved || !saved.data) return;
        const mins = Math.max(1, Math.round((now - saved.at) / 60000));
        if(!confirm(mins + '분 전에 저장되지 않은 작성 내용이 있습니다. 불러올까요?')){
          this.clearDraft();   // 의도적 폐기
          return;
        }
        const d = saved.data;
        Object.keys(d).forEach(k => {
          if(k === '__content') return;
          // 🔴 d_pass 는 JSON 직렬화로 문자열이 된다. Date 로 되돌려야 DatePicker 가 안 깨진다.
          this.sendData[k] = (k === 'd_pass' && d[k]) ? new Date(d[k]) : d[k];
        });
        if(d.__content !== undefined) this.content = d.__content;
        this.autoSaveFlg = true;
      } catch(e){ console.log('임시저장 복원 실패:', e); }
    },

    // 기사 잠금 해제. 이탈 경로가 여러 갈래라 한 곳으로 모았다.
    releaseLock() {
      if(!this.lockFlg) return;
      this.$http.post('/api/writeArticles/lock', {id: this.sendData.id, name: this.$store.state.AppActiveUser.name, mno: this.$store.state.AppActiveUser.id, lock: 'open'})
        .catch(function (error) { console.log(error); });
    },

    // 401 을 만났을 때 단 한 번만 도는 처리. 두 번째 호출부터는 무시한다.
    handleUnauthorized() {
      if(this.authRedirecting) return;
      this.authRedirecting = true;
      // 🔴 로그인으로 보내기 **전에** 작성 내용을 남긴다. 이 순서가 뒤바뀌면
      //    재로그인 후 돌아와도 복원할 것이 없다.
      this.saveDraft('401');
      alert('로그인 해주세요!');
      const cur = this.$router.history.current;
      // 🔴 `to` 가 **첫 쿼리 파라미터**여야 한다. Login.vue 의 redirect() 가
      //    첫 '&' 를 '?' 로 바꿔 파싱하는 방식이라 순서가 바뀌면 재로그인 후 복귀가 깨진다.
      this.$router.push({ path: '/pages/login', query: Object.assign({ to: cur.path }, cur.query) })
        .catch(() => {});
    },

    // 신규 기사 초안을 만들고 ?id= 로 넘어간다. 신규 작성과 연합뉴스 수신함이 함께 쓴다.
    // wireId 가 있으면 만들어진 기사번호를 수신함에 기록해 **중복 작성**을 막는다.
    createDraft(wireId) {
      const thisIns = this;
      this.$http.post('/api/writeArticles', this.sendData)
        .then(function (response) {
          thisIns.autoSaveFlg = false;
          const newId = response.data.id;
          if (wireId && newId) {
            // 연결에 실패해도 기사 작성은 계속된다(중복 표시만 안 될 뿐).
            thisIns.$http.post('/api/wire/markUsed', {
              id: wireId, articleId: newId,
              memberId: thisIns.$store.state.AppActiveUser.id,
            }).catch(function () {});
          }
          thisIns.$router.push({path: thisIns.$route.path, query: {id: newId}});
          thisIns.$vs.loading.close();
        })
        .catch(function (error) {
          thisIns.$vs.notify({title:'Error', text: error, color:'danger',
            iconPack:'feather', icon:'icon-alert-circle'});
          thisIns.$vs.loading.close();
        });
    },
    // 에디터 DOM/표시 상태를 확인
    _isQuillUsable(quill) {
      if (!quill || !quill.root) return false
      // DOM에 붙어 있는지
      if (!document.body.contains(quill.root)) return false
      // 표시중인지 (display:none 이면 offsetParent가 null)
      if (quill.root.offsetParent === null) return false
      return true
    },

    // 안전한 setSelection (보장될 때만 실행, 필요시 rAF로 다음 페인트에 시도)
    _safeSetSelection(quill, index, length = 0) {
      if (!this._isQuillUsable(quill)) return
      try {
        quill.setSelection(index, length, 'user')
      } catch (e) {
        // DOM 갱신 직후라면 다음 프레임에서 재시도
        requestAnimationFrame(() => {
          if (this._isQuillUsable(quill)) {
            try { quill.setSelection(index, length, 'user') } 
            catch (_) {
              console.log(_)
            }
          }
        })
      }
    },
    _hasCaptionBelow(quill, imgIndex) {
      // 이미지가 들어간 블록 다음 라인 텍스트를 점검해 "ⓒ" 또는 "[사진]"으로 시작하면 캡션 있다고 판단
      // const doc = quill.getContents()
      // imgIndex 이후 첫 줄의 시작 위치를 대략 찾기 위해 한 글자 뒤로 이동
      const after = imgIndex + 1
      // 해당 위치의 라인 범위 가져오기
      const line = quill.getLine(after)
      if (!line || !line[0]) return false
      const lineIndex = quill.getIndex(line[0])
      const lineText = quill.getText(lineIndex, line[0].length()).trim()
      return /^ⓒ(\s|$)|^\[사진\]/.test(lineText)
    },
    onPhotosPicked (items) {
      // 5초 타임락: 이미 최근에 실행됐다면 무시
      if (Date.now() < this.insertLockedUntil) {
        this.$vs.notify({ title: '잠깐!', text: '이미지 삽입이 잠시 잠겨 있어요. 몇 초 후 다시 시도해주세요.', color: 'warning' })
        return
      }
      this.insertLockedUntil = Date.now() + 5000
      // Quill 에 현재 커서 위치에 이미지 삽입
      const quill = this.$refs.quillEditor_descr?.quill
      if (!quill) {
        this.$vs.notify({ title: '에디터 준비 안됨', text: '본문 에디터가 아직 준비되지 않았어요.', color: 'warning' })
        return
      }
      const range = quill.getSelection(true) || { index: quill.getLength() }

      let insertIndex = range.index
      // items.forEach((it) => {
      //   // 캡션(제목) 한 줄 넣고 싶다면 아래 주석 해제
      //   const caption = it.contents ? `${it.contents}` : ''
      //   quill.insertText(insertIndex, caption, 'user')
      //   quill.insertEmbed(insertIndex, 'image', it.src, 'user')
      //   insertIndex += caption.length + 2
      // })
      for(const it of items.reverse()){
        const caption = it.contents ? `${it.contents}` : ''
        // console.log("caption: ", it, caption)
        quill.insertEmbed(insertIndex, 'image', it.src, 'user')
        quill.insertText(insertIndex+1, "\n"+caption+"\n", 'user')
      }

      // quill.setSelection(insertIndex, 0, 'user')
      this._safeSetSelection(quill, insertIndex, 0)
      this.$vs.notify({ title: '삽입 완료', text: `${items.length}개의 이미지를 본문에 삽입했어요.`, color: 'primary' })
    },
    async fetchTitleSuggestions() {
      const plainText = this.$refs.quillEditor_descr.quill.getText().trim();
      if (!plainText) {
        this.$vs.notify({ title: '알림', text: '기사 내용이 비어있습니다.', color: 'warning' });
        return;
      }
      this.loadingTitle = true;
      this.showTitlePopup = true;
      try {
        const res = await this.$http.post('/api/writeArticles/newsai/title', {
          title: this.$refs.quillEditor_b_sbj.quill.getText(),
          content: plainText
        });
        this.titleCandidates = res.data.extractor || [];
      } catch (e) {
        this.$vs.notify({ title: '에러', text: '제목 생성 실패', color: 'danger' });
      } finally {
        this.loadingTitle = false;
      }
    },
    async fetchSubtitleSuggestions() {
      const plainText = this.$refs.quillEditor_descr.quill.getText().trim();
      if (!plainText) {
        this.$vs.notify({ title: '알림', text: '기사 내용이 비어있습니다.', color: 'warning' });
        return;
      }
      this.loadingSubtitle = true;
      this.showSubtitlePopup = true;
      try {
        const res = await this.$http.post('/api/writeArticles/newsai/subtitle', {
          title: this.$refs.quillEditor_b_sbj.quill.getText(),
          content: plainText
        });
        this.subtitleCandidates = res.data.extractor || [];
      } catch (e) {
        this.$vs.notify({ title: '에러', text: '부제목 생성 실패', color: 'danger' });
      } finally {
        this.loadingSubtitle = false;
      }
    },
    async fetchKeywordSuggestions() {
      const plainText = this.$refs.quillEditor_descr.quill.getText().trim();
      if (!plainText) {
        this.$vs.notify({ title: '알림', text: '기사 내용이 비어있습니다.', color: 'warning' });
        return;
      }
      this.loadingKeyword = true;
      this.showKeywordPopup = true;
      try {
        const res = await this.$http.post('/api/writeArticles/newsai/keyword', {
          title: '임시제목',
          content: plainText
        });
        this.keywordCandidates = res.data.extractor || [];
      } catch (e) {
        this.$vs.notify({ title: '에러', text: '키워드 생성 실패', color: 'danger' });
      } finally {
        this.loadingKeyword = false;
      }
    },
    applyTitle() {
      const editor = this.$refs.quillEditor_b_sbj.quill;
      editor.setText(this.selectedTitle);
      this.showTitlePopup = false;
    },
    applySubtitles() {
      const editor = this.$refs.quillEditor_s_sbj.quill;
      editor.setText(this.selectedSubtitles.join('\n'));
      this.showSubtitlePopup = false;
    },
    applyKeywords() {
      if (!this.selectedKeywords.length) return;
      const uniqueKeywords = [...new Set(this.selectedKeywords)];
      this.sendData.tag = uniqueKeywords;
      this.showKeywordPopup = false;
    },
    openNewsAIModal() {
      if (!this.content || this.content.trim() === '') {
        this.$vs.notify({ title: '알림', text: '기사 내용을 먼저 입력해주세요.', color: 'warning' });
        return;
      }
      this.showNewsAIModal = true;
    },
    async generateNewsAIImage() {
     const plainText = this.$refs.quillEditor_descr.quill.getText().trim();

      if (!plainText) {
        this.$vs.notify({ title: '알림', text: '기사 내용이 비어있습니다.', color: 'warning' });
        return;
      }

      const payload = {
        contents: plainText,
        aspect_ratio: this.selectedAspectRatio,
        style: this.selectedStyle
      };

      this.$vs.loading({
        scale: 1.5
      });
      try {
        const res = await this.$http.post(
          '/api/writeArticles/newsai/image',
          payload,
          {
            headers: {
              'Content-Type': 'application/json'
            },
            timeout: 180000 // 3분
          }
        );

        if (res.data && res.data.status === 200) {
          const imageUrl = res.data.imageUrl;
          const editor = this.$refs.quillEditor_descr.quill;
          const range = editor.getSelection(true);
          const idx = range.index;
          editor.insertEmbed(idx, 'image', imageUrl);
          // editor.insertText(idx+1, '\nⓒ중앙신문 AI 삽화 이미지\n', 'user')
          // ✅ 뉴스 AI 이미지 생성 후 썸네일 자동 활성화
          this.thumbnailFlg = true;
          this.showNewsAIModal = false;
        } else {
          this.$vs.notify({ title: '오류', text: '이미지 생성에 실패했습니다.', color: 'danger' });
        }
      } catch (err) {
        this.$vs.notify({ title: '에러', text: '뉴스AI 요청 실패', color: 'danger' });
        console.error(err);
      }
      this.$vs.loading.close(); 
    },
    onEditorReady() {
      this.bodyFindReady = true;
      const quill = this.$refs.quillEditor_descr.quill;
      
      // 드래그 앤 드롭
      quill.root.addEventListener('drop', async (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Quill 이 자동 삽입 못하도록 dataTransfer 비움
        if (e.dataTransfer) {
          e.dataTransfer.clearData();
        }
        if (e.dataTransfer && e.dataTransfer.files.length) {
          const file = e.dataTransfer.files[0];
          if (file.type.startsWith('image/')) {
            const currentRange = quill.getSelection(true) || { index: quill.getLength(), length: 0 };

            const imageUrl = await this.uploadImageToServer(file);
            if (!imageUrl) return;   // 실패는 이미 안내했다. 빈 <img> 를 넣지 않는다.
            quill.setSelection(currentRange.index, 0);
            quill.insertEmbed(currentRange.index, 'image', imageUrl);
          }
        }
      });

      // dragover
      quill.root.addEventListener('dragover', (e) => e.preventDefault());

      // 붙여넣기
      quill.root.addEventListener('paste', async (e) => {
        const clipboardItems = e.clipboardData.items;
        for (const item of clipboardItems) {
          if (item.type.indexOf('image') !== -1) {
            e.preventDefault();
            const file = item.getAsFile();
            const imageUrl = await this.uploadImageToServer(file);
            if (!imageUrl) continue;   // 실패는 이미 안내했다. 빈 <img> 를 넣지 않는다.
            const range = quill.getSelection(true) || { index: quill.getLength(), length: 0 };
            quill.insertEmbed(range.index, 'image', imageUrl);
          }
        }
      });

      // 툴바 버튼
      quill.getModule('toolbar').addHandler('image', () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/*');
        input.click();
        input.onchange = async () => {
          const file = input.files[0];
          if (file) {
            const imageUrl = await this.uploadImageToServer(file);
            if (!imageUrl) return;   // 실패는 이미 안내했다. 빈 <img> 를 넣지 않는다.
            const range = quill.getSelection(true) || { index: quill.getLength(), length: 0 };
            quill.insertEmbed(range.index, 'image', imageUrl);
          }
        };
      });
    },

    // name 은 Blob 을 올릴 때만 쓴다(File 은 자기 이름을 갖고 있다).
    // 서버가 확장자로 처리 분기를 하므로(허용 외 확장자는 sharp 로 JPG 변환)
    // 붙여넣기로 만든 Blob 에는 반드시 이름을 붙여 보낸다.
    // 🔴 **실패하면 반드시 빈 문자열을 주고, 부르는 쪽은 그걸 넣지 않는다.**
    //    예전에는 실패해도 `''` 를 돌려줬는데 툴바·드래그·붙여넣기 세 군데가
    //    그걸 그대로 `insertEmbed` 해서 `<img src="">` 가 본문에 박혔다.
    //    사용자 눈에는 "아무 일도 안 일어난다"로 보이고, 그 깨진 이미지가
    //    저장까지 됐다(2026-09-30 지적).
    //
    // ⚠ 서버(nginx)가 받는 한계는 50MB 다. 여기서 먼저 걸러 주면 큰 파일을
    //   끝까지 올려놓고 413 을 받는 헛수고를 안 한다.
    // ⚠ `quiet` 는 **붙여넣기 필터 전용**이다. 워드 문서를 붙이면 이미지가 수십 장
    //   한꺼번에 올라가는데, 장마다 스피너를 열고 경고를 띄우면 화면이 도배된다.
    //   그쪽은 pasteFilter 가 "N장 중 M장 실패"로 한 번에 알려 준다.
    async uploadImageToServer(file, name, opts) {
      const quiet = !!(opts && opts.quiet);
      const MAX_MB = 50;
      const warn = (text) => {
        if (quiet) return;
        this.$vs.notify({ title: '이미지 업로드', text, color: 'danger',
                          iconPack: 'feather', icon: 'icon-alert-circle', time: 6000 });
      };
      if (file && file.size > MAX_MB * 1024 * 1024) {
        warn(`사진이 너무 큽니다 (${(file.size / 1048576).toFixed(1)}MB). ${MAX_MB}MB 이하로 줄여서 올려 주세요.`);
        return '';
      }
      const formData = new FormData();
      if (name) formData.append('image', file, name);
      else formData.append('image', file);
      // 큰 사진은 몇 초 걸린다. 표시가 없으면 멈춘 것처럼 보인다.
      if (!quiet) this.$vs.loading({ scale: 1.5 });
      try {
        const response = await this.$http.post('/api/writeArticles/upload', formData, {
          headers: {'Content-Type': 'multipart/form-data'}
        });
        const data = response.data;
        if (!data || !data.success) throw new Error('Upload failed');
        console.log('업로드 성공:', data.url);
        return data.url;
      } catch (err) {
        console.error('이미지 업로드 실패:', err);
        // 왜 안 됐는지를 알려 준다. 413 은 사용자가 바로 손쓸 수 있는 원인이다.
        const st = err && err.response && err.response.status;
        if (st === 413) warn(`사진 용량이 서버 한계(${MAX_MB}MB)를 넘었습니다. 줄여서 올려 주세요.`);
        else if (st === 401) warn('로그인이 풀렸습니다. 다시 로그인한 뒤 올려 주세요.');
        else warn('사진을 올리지 못했습니다' + (st ? ` (오류 ${st})` : '') + '. 잠시 뒤 다시 시도해 주세요.');
        return '';
      } finally {
        if (!quiet) this.$vs.loading.close();
      }
    },
    changeRelType(){
      // console.log(this.relNewsListType);
      if(this.relNewsListType == "newRanking"){
        this.swipeRelList();
      }else if(this.sendData.rel.length == 0){
        this.sendData.rel = this.tmp_rel;
      } 
      this.setNewsRelList(this.relNewsListType);
    },
    newsRelChange(){
      // console.log(newsRel, this.sendData.rel)
      // if(newsRel.flg){ this.sendData.rel = this.sendData.rel.filter(e => e.id != newsRel.id) }
      // else{ this.sendData.rel.push(newsRel); }
      if(this.sendData.rel.length > 5){
        this.sendData.rel.splice(5);
        // this.newsRelList[idx].flg = false;
        // console.log(this.newsRelList)
        this.$vs.notify({
          title:'Error',
          text: '관련기사는 최대 5개까지 입력가능합니다.',
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      }
    },
    swipeRelList(){
      this.sendData.rel = [];
    },
    setNewsRelList(type){
      const thisIns = this;
      let newRel = thisIns.sendData.rel.slice();
      for(var i in thisIns.sendData.rel){
        let tmpRel = thisIns.newsRelListSearch[type].findIndex(e => e.id == thisIns.sendData.rel[i].id);
        if( tmpRel > -1 ){
          newRel[i] = thisIns.newsRelListSearch[type][tmpRel];
        }
      }
      thisIns.sendData.rel = newRel;
      // thisIns.tmp_rel = newRel;
    },
    setInnerNewsRel(){
      if(this.relNewsList.length > 0){
        const existingIds = this.sendData.rel.map(item => item.id);
        const newItems = this.relNewsList.filter(item => !existingIds.includes(item.id));
        this.sendData.rel = this.sendData.rel.concat(newItems);
        
        // Quill 인스턴스 가져오기
        const quill = this.$refs.quillEditor_descr.quill;
        quill.focus();
        const selection = quill.getSelection();
        const currentIndex = selection ? selection.index : quill.getLength() - 1;
     
        // 새로운 Delta 생성
        const Delta = Quill.import('delta');
        const newDelta = new Delta();
        
        // 현재 위치까지 유지
        newDelta.retain(currentIndex);
        
        // 제목 추가
        newDelta.insert('▼ 관련기사 보기');
        newDelta.insert('\n', { header: 4 });
        
        // 각 관련 기사 추가
        for(const rel of this.relNewsList){
          const linkText = rel.b_sbj.replace(/<\/?strong>/g, '');
          const linkUrl = `https://www.jasm.co.kr/news/view/${rel.id}`;
          
          newDelta.insert(linkText, { link: linkUrl });
          newDelta.insert('\n', { header: 4 });
        }
        
        // updateContents를 사용하여 변경사항 적용
        quill.updateContents(newDelta);
        
        // 포커스 및 커서 위치 복원
        quill.focus();
        const insertedLength = '▼ 관련기사 보기\n'.length + 
                              this.relNewsList.reduce((sum, rel) => 
                                sum + rel.b_sbj.replace(/<\/?strong>/g, '').length + 1, 0);
        quill.setSelection(currentIndex + insertedLength);
      }
      this.relNewsModalActive = false;
    },
    getRankingNewsList(){
      let type = 'ranking';
      const thisIns = this;
      this.$vs.loading({
        scale: 1.5
      });
      this.$http.post('/api/getNewsList/ranking', {category1: 0})
        .then(function (response) {
          let getData = response.data;
          getData = getData.slice(0,5)
          console.log('ranking: ', getData)
          thisIns.newsRelListSearch[type] = getData.filter(e => thisIns.newsRelList.findIndex(e2 => e2.id == e.id) < 0);
          if(!thisIns.sendData.rel || thisIns.sendData.rel.length == 0){
            thisIns.sendData.rel = getData;
          }
          thisIns.setNewsRelList(type);
          console.log(thisIns.newsRelListSearch)
          thisIns.$vs.loading.close();
        })
        .catch(function (error) {
          // 401 판정·이동은 handleUnauthorized 한 곳으로 모았다(2026-09-25).
          if(thisIns.isAuthError(error)){
            thisIns.handleUnauthorized();
            return;
          }
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
          thisIns.$vs.loading.close(); 
        });
    },
    getNewsList(type='search') {
      let endDate = moment();
      if(moment(this.sendData.d_pass).format('X') > endDate.format('X')){
        endDate = moment(this.sendData.d_pass);
      }
      let data = {
        startRow: 0,
        itemsPerPage: 20,
        category1: this.tmpCategory1,
        searchText: this.searchText,
        startDate: type=="search" ? moment().subtract(6, 'month') : moment().subtract(1, 'week'),
        endDate: endDate.add(10, 'm'),
        department: '',
        level: this.activeUserInfo.level,
        id: this.activeUserInfo.id,
        relNews: true,
      }
      
      this.$vs.loading({
        scale: 1.5
      });
      const thisIns = this;
      let getData = [];
      this.$http.post('/api/getNewsList', data)
        .then(function (response) {
          getData = response.data[1];
          thisIns.newsRelListSearch[type] = getData.filter(e => thisIns.newsRelList.findIndex(e2 => e2.id == e.id) < 0);
          thisIns.setNewsRelList(type);
          // console.log(thisIns.newsRelListSearch)
          thisIns.$vs.loading.close();          
        })
        .catch(function (error) {
          // 401 판정·이동은 handleUnauthorized 한 곳으로 모았다(2026-09-25).
          if(thisIns.isAuthError(error)){
            thisIns.handleUnauthorized();
            return;
          }
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
          thisIns.$vs.loading.close(); 
        });
    },
    getNewsList2() {
      let endDate = moment();
      if(moment(this.sendData.d_pass).format('X') > endDate.format('X')){
        endDate = moment(this.sendData.d_pass);
      }
      let data = {
        startRow: 0,
        itemsPerPage: 20,
        category1: this.tmpCategory1,
        searchText: this.searchText,
        startDate: moment().subtract(6, 'month'),
        endDate: endDate.add(10, 'm'),
        department: '',
        level: this.activeUserInfo.level,
        id: this.activeUserInfo.id,
        relNews: true,
      }
      this.$vs.loading({
        scale: 1.5
      });
      const thisIns = this;
      let getData = [];
      this.$http.post('/api/getNewsList', data)
        .then(function (response) {
          getData = response.data[1];
          thisIns.relNewsSearch = getData;
          thisIns.$vs.loading.close();          
        })
        .catch(function (error) {
          // 401 판정·이동은 handleUnauthorized 한 곳으로 모았다(2026-09-25).
          if(thisIns.isAuthError(error)){
            thisIns.handleUnauthorized();
            return;
          }
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
          thisIns.$vs.loading.close(); 
        });
    },
    selectOkCategories1() {
      
      // '전체' 는 DB 에 있고 sort_order 0 이라 목록 맨 앞으로 온다(login.js 가 정렬해 준다).
      this.categories1 = this.$store.state.categories1;
      this.categories1_2 = this.$store.state.categories1_2;
      this.categories2 = this.$store.state.categories2;
      this.categories2_2 = this.$store.state.categories2_2;

      this.sendData.category1 = []
      // for(var idx in this.form.data.category1.categories) {
      //   console.log('idx:', idx)
      //   if(this.form.data.category1.categories[idx]) {
      //     this.sendData.category1.push({name: this.categories1[idx].name, code: this.categories1[idx].code})
      //   }
      // }

      for(var idx in this.categories1) {
        if(this.form.data.category1.categories[idx]) {
          this.sendData.category1.push({name: this.categories1[idx].name, code: this.categories1[idx].code})
        }
      }

      this.form.data.category1.toString = ``
      // for(var idx in this.form.data.category1.categories) {
      //   if(this.form.data.category1.categories[idx]) {

      //     if(this.form.data.category1.toString == ``) {

      //       this.form.data.category1.toString += `${this.categories1[idx].name}`
      //     }
      //     else {

      //       this.form.data.category1.toString += `, ${this.categories1[idx].name}`
      //     }
      //   }
      // }
      for(idx in this.categories1) {
        if(this.form.data.category1.categories[idx]) {

          if(this.form.data.category1.toString == ``) {

            this.form.data.category1.toString += `${this.categories1[idx].name}`
          }
          else {

            this.form.data.category1.toString += `, ${this.categories1[idx].name}`
          }
        }
      }

      var dataToAvoidBug = []
      for(idx in this.sendData.category1) {

        dataToAvoidBug.push(this.sendData.category1[idx])
      }

      this.setCategory1(dataToAvoidBug)
    },
    selectOkCategories2() {

      this.sendData.category2_2 = []

      for(var idx in this.categories2_2_view) {

        if(this.form.data.category2_2.categories[idx]) {
          this.sendData.category2_2.push({name: this.categories2_2_view[idx].name, code: this.categories2_2_view[idx].code})
        }
      }

      this.form.data.category2_2.toString = ``
      for(idx in this.categories2_2_view) {
        if(this.form.data.category2_2.categories[idx]) {

          if(this.form.data.category2.toString == "카테고리2-2 선택" || this.form.data.category2.toString == ``) {

            this.form.data.category2.toString += `${this.categories2_view[idx].name}`
          }
          else {

            this.form.data.category2.toString += `, ${this.categories2_view[idx].name}`
          }
        }
      }

      var dataToAvoidBug = []
      for(idx in this.sendData.category2) {

        dataToAvoidBug.push(this.sendData.category2[idx])
      }

      this.setCategory2(dataToAvoidBug)
    },
    sendDataToServer(){ //<-----------------------------------------------------------------------------------------Server 보내는 함수
      // const re = /(\[|<|\()(속보|인사|부고|컨콜|\d보|종합)(\]|>|\))/;
      // const timeSetting = 10;
      // console.log('senddata: ', this.sendData, !this.sendData.mainTitle.match(re), (this.sendData.state.code == 1 || this.sendData.state.code == 2) && 
      //         this.pastState != 1 && !this.sendData.mainTitle.match(re) &&
      //         this.sendData.category1.findIndex(e => e.code == 10) == -1 &&
      //         moment(this.sendData.d_pass).add(-timeSetting, 'minute') < this.lastArticleTime);
      // return;

      if(this.sendData.state.code == 1 && moment(this.sendData.d_pass).format('X') > moment().format('X')){
          // this.$vs.notify({
          //   title:'Error',
          //   text: '엠바고 시간이 되지 않아 송고완료할 수 없습니다.',
          //   color:'danger',
          //   iconPack: 'feather',
          //   icon:'icon-alert-circle'})
          this.$vs.dialog({
              type: 'alert',
              color: 'danger',
              title: `Error`,
              text: '엠바고 시간이 되지 않아 송고완료할 수 없습니다.',
          })
          return;
      }else if(this.sendData.state.code == 2 && moment(this.sendData.d_pass).format('X') < moment().format('X')){
          // this.$vs.notify({
          //   title:'Error',
          //   text: '엠바고 시간이 이미 지났습니다. 시간을 확인해주세요.',
          //   color:'danger',
          //   iconPack: 'feather',
          //   icon:'icon-alert-circle'})
          this.$vs.dialog({
              type: 'alert',
              color: 'danger',
              title: `Error`,
              text: '엠바고 시간이 이미 지났습니다. 시간을 확인해주세요.',
          })
          return;
      // }else if((this.sendData.state.code == 1 || this.sendData.state.code == 2) && 
      //         this.pastState != 1 && !this.sendData.mainTitle.match(re) &&
      //         this.sendData.category1.findIndex(e => e.code == 10) == -1 &&
      //         moment(this.sendData.d_pass).add(-timeSetting, 'minute') < this.lastArticleTime){
      //     this.$vs.dialog({
      //         type: 'alert',
      //         color: 'danger',
      //         title: `Error`,
      //         text: `이전 기사 송고 후 시간이 얼마 지나지 않았습니다. ${timeSetting}분 이후에 송고하거나 송고예약을 해주세요.`,
      //     })
      //     return;
      }
      // 관련기사 최소 개수 제한은 없앴다(2026-09-02, 요청).
      // 최대 5개 제한은 setNewsRel() 쪽에 그대로 있다.
      this.$vs.loading({
        scale: 1.5
      });
      // this.sendData.mainTitle = this.sendData.mainTitle;
      // this.sendData.portalAction = [];
      if(this.portalFlg){
        let tmpOutSite = this.sendData.out_site.split("|");
        console.log('out_site: ', tmpOutSite);
        for(var i = 0; i<this.sendData.portalAction.length; i++){
          // this.sendData.portalAction.push(JSON.parse(JSON.stringify(this.portals[i])));
          if(tmpOutSite.find(e => e.toLowerCase() == this.sendData.portalAction[i].name.toLowerCase() || e == this.sendData.portalAction[i].oldName )) this.sendData.portalAction[i]['action'] = "U";
          else this.sendData.portalAction[i]['action'] = "I";
        }
        console.log('portalAction: ', this.sendData.portalAction);
      }else{
        this.sendData.portalAction = [];
      }
      // let sqareThumbnail = this.sendData.category1.findIndex(e => e.code == 11);
      // if(this.thumbnailFlg){
      //   this.sendData.thumbnail = sqareThumbnail + ';' + this.thumbnail + ';' + this.thumbnailOption + ';' + this.thumbnailImageNum;
      // }else{
      //   this.sendData.thumbnail = sqareThumbnail + ';;';
      // }
      if(this.thumbnailFlg){
        this.sendData.thumbnail = this.thumbnail2 + ';' + this.thumbnail + ';' + this.thumbnailOption + ';' + this.thumbnailImageNum;
      }else{
        this.sendData.thumbnail = this.thumbnail2 + ';;;';
      }
      if(this.sendData.portalTitle == ''){
        this.sendData.portalTitle = this.sendData.mainTitle;
      }
      const thisIns = this;
      // console.log('this.sendData:', this.sendData, this.sendData.subTitle.split('</p><p>').join('\n').split('<p>').join('').split('</p>').join(''))
      this.$http.post('/api/writeArticles', this.sendData)
        .then(function () {
          // 서버에 들어갔으니 임시저장은 필요 없다(기준선도 같이 갱신된다).
          thisIns.clearDraft();
          thisIns.newsDetailModalActive = false;
          thisIns.$vs.loading.close();
          if(!thisIns.autoSaved){
            thisIns.autoSaveFlg = false;
            // 🔴 **새로고침 뒤에는 prevRoute 가 vue-router 의 시작 라우트**(path '/')다.
            //    `includes('login')` 검사만으로는 걸러지지 않아 `/` 로 갔고,
            //    router 의 `{ path: '/', redirect: '/pages/login' }` 때문에
            //    **로그인 화면으로 돌아가 보였다.** 로그인이 풀린 게 아니었다.
            backTo(thisIns.prevRoute, '/newsList');
            // if(thisIns.prevRoute.path == '/writeArticles') thisIns.$router.go(-2);
            // else thisIns.$router.back();
            // thisIns.$router.push({path: '/newsList'});
            alert('기사를 저장하였습니다.')
          }
        })
        .catch(function (error) {
          // 401 판정·이동은 handleUnauthorized 한 곳으로 모았다(2026-09-25).
          if(thisIns.isAuthError(error)){
            thisIns.handleUnauthorized();
            return;
          } else if(error.response && error.response.status === 403) {
            thisIns.$vs.dialog({ type: 'alert', color: 'danger', title: 'Error', text: error.response.data.msg });
            thisIns.$vs.loading.close();
            return;
          }
          thisIns.$vs.notify({
            title:'Error',
            text: error,
            color:'danger',
            iconPack: 'feather',
            icon:'icon-alert-circle'})
          thisIns.$vs.loading.close();  
        });
    },
    onEditorChange(event) {
      if(!this.initImage && this.timeFlg) this.autoSaveFlg = true;
      this.sendButtonDisable = true;
      const quill = this.$refs.quillEditor_descr?.quill
      if (!this._isQuillUsable(quill)) return

      // 🔴 **여기서 DOM 을 건드리지 않는다.** 2026-09-26 이전에는 키 입력마다
      //    (1) 모든 줄 × 모든 자식노드를 돌며 style.color 를 35색 허용목록과 대조해
      //        지우고, (2) `root.innerHTML` 에 정규식을 돌려 되썼다.
      //    퀼 1.x 의 Scroll 은 MutationObserver 로 DOM 을 감시하다 다시 파싱하므로,
      //    innerHTML 되쓰기는 Delta·실행취소 이력·커서 위치를 어긋나게 만든다.
      //    색·배경·&nbsp; 는 이제 **붙여넣기 시점**에 걸러진다(utils/pasteFilter.js).
      //    남은 것은 제목·부제의 줄 수 제한뿐이고, 그것도 Delta API 로 처리한다.
      if (event.quill === this.$refs.quillEditor_b_sbj.quill) {
        this._limitLines(event.quill, 1);
        this._stripFormats(event.quill, ['bold']);
      }
      else if (this.$refs.quillEditor_s_sbj && event.quill === this.$refs.quillEditor_s_sbj.quill) {
        this._limitLines(event.quill, 4);
        this._stripFormats(event.quill, ['bold', 'background']);
      }
      else if (event.quill === this.$refs.quillEditor_descr.quill) {
        if (typeof this.countCharacter === 'function') {
          requestAnimationFrame(() => this.countCharacter(event))
        }
      }
    },

    // 이미지 크기·정렬을 모듈이 DOM 에서 직접 바꾸면 퀼 모델이 모른다.
    // 한 글자를 넣었다 빼서 text-change 를 한 번 일으켜 v-model·임시저장에 태운다.
    _nudgeEditor() {
      const q = this.$refs.quillEditor_descr && this.$refs.quillEditor_descr.quill;
      if (!this._isQuillUsable(q)) return;
      q.insertText(0, ' ', 'user');
      q.deleteText(0, 1, 'user');
    },

    // 줄 수를 max 로 자른다. 초과분만 지우므로 커서와 실행취소가 살아 있다.
    // 🔴 예전에는 `setContents(getLines()[0].cache.delta)` 였다. `cache` 는 퀼 내부
    //    필드고, setContents 는 문서를 통째로 갈아 끼워 실행취소 이력이 끊긴다.
    _limitLines(quill, max) {
      const lines = quill.getLines();
      if (lines.length <= max) return;
      const last = lines[max - 1];
      // 블록 blot 의 length() 에는 끝의 줄바꿈이 들어 있다. 그 줄바꿈부터 문서 끝까지 지운다.
      const end = quill.getIndex(last) + last.length() - 1;
      const total = quill.getLength() - 1;      // 퀼이 항상 갖고 있는 맨 끝 줄바꿈 제외
      if (total > end) quill.deleteText(end, total - end, 'user');
    },

    // 제목·부제에 들어오면 안 되는 서식을 벗긴다(굵게·배경 등).
    // 변경이 있을 때만 건드려서 무한 재진입을 막는다.
    _stripFormats(quill, names) {
      const ops = (quill.getContents().ops || []);
      const hit = names.filter(n => ops.some(o => o.attributes && o.attributes[n] != null));
      if (!hit.length) return;
      const len = quill.getLength();
      hit.forEach(n => quill.formatText(0, len, n, false, 'user'));
    },
    setTitleTag(){
      console.log(this.$refs.titleTagSelect.$el.querySelector('input'));
      if(this.tagFocusFlg) this.$refs.titleTagSelect.$el.querySelector('input').focus();
      this.tagFocusFlg = false;
      this.sendData.titleTags.splice(3)
    },
    setSelected(){
      console.log(this.$refs.tagSelect.$el.querySelector('input'));
      if(this.tagFocusFlg) this.$refs.tagSelect.$el.querySelector('input').focus();
      this.tagFocusFlg = false;
    },
    loadData(data){
      var textTemp = data;
      // 이관 기사 content 는 블록 태그 사이에 CRLF 가 들어 있다.
      // 브라우저는 블록 사이 공백을 무시하지만 Quill 은 빈 문단으로 바꿔 버려서,
      // 문단마다 빈 줄이 두 개씩 더 생긴다(실측 70,129건).
      // 닫는 블록 태그 뒤의 공백만 걷어낸다 — 인라인 태그 사이나 <br> 뒤의
      // 줄바꿈은 의미가 있을 수 있어 건드리지 않는다.
      if (typeof textTemp === 'string') {
        textTemp = textTemp.replace(BLOCK_GAP_RE, '$1');
      }
      var root="/news/";
      var i = 1;
      var tmp;
      var imgText1 = '<p><img src="';
      var imgText2 = '" width="';
      var imgText3 = '" height="';
      var imgText4 = '"></p>';
      while (textTemp.match('<@IMG'+i+'>')){
        tmp = textTemp.match('<@IMG'+i+'>')
        textTemp = textTemp.replace(tmp[0],imgText1 + this.imgUrl(this.sendData.images[i-1].img) + imgText2 + this.sendData.images[i-1].width + imgText3 + imgText4 + "<p>" + this.sendData.images[i-1].img_c + "</p>");
        i++;
      }
      this.initImage = true;
      return spaceArticleParagraphs(textTemp);
    },
    dataToArticle(cb){
      if(this.sendData.mainTitle == '' && this.sendData.portalTitle){ this.sendData.mainTitle = this.sendData.portalTitle; }
      else if(this.sendData.portalTitle == '' && this.sendData.mainTitle){ this.sendData.portalTitle = this.sendData.mainTitle; }
      if(this.sendData.state.code == 1 || this.sendData.state.code == 2){
        if(this.sendData.category1.findIndex(e => e.code == 3) > -1 && 
          this.snsKeyword.find(e => this.sendData.mainTitle.indexOf(e) > -1 || this.content.indexOf(e) > -1)){
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: `위험`,
                text: '기사를 사회 섹션으로 분류시 네이버 판 편집 배치에서 제외될 수 있습니다.',
            })
        }
        // for(const fc of this.forceCategoryList){
        //   // console.log(fc, this.sendData.category1.findIndex(e => e.code == fc.category1), 
        //   // this.sendData.mainTitle.indexOf(fc.keyword), this.content.indexOf(fc.keyword),
        //   // this.sendData.tag.findIndex(e => e.indexOf(fc.keyword) > -1))
        //   if(this.sendData.category1.findIndex(e => e.code != fc.category1) > -1 && 
        //     (this.sendData.mainTitle.indexOf(fc.keyword) > -1 || this.content.indexOf(fc.keyword) > -1 
        //     // || this.sendData.tag.findIndex(e => e.indexOf(fc.keyword) > -1) > -1
        //     )){
        //       this.$vs.dialog({
        //           type: 'alert',
        //           color: 'warning',
        //           title: `위험`,
        //           text: `기사의 카테고리 설정을 ${this.categories1.find(e => e.code == fc.category1).name}로 변경하는걸 고려해주세요`,
        //       })
        //   }
        // }
      }
      this.sendData.images = [];
      console.log('content: ', this.content, this.sendButtonDisable)
      var textTemp = this.content.replace(/<p> ?&nbsp; ?<\/p>/g, '<p><br></p>').replace(/&nbsp;/g,'').replace(/&quot;/g,'').replace(/(border-top|background):(\s?url\(data:image\/svg\+xml;)?[^;]*;/g,'');
      var tmp, tmp2, tmp3, tmp4 =[]; 
      var tmpWidth, i=1;
      // textTemp = textTemp.replace(/<\/pre[^>]*>/, "</div>").replace(/<pre[^>]*>/, "<div style='background-color: inherit;color: inherit;margin: 17px 0;padding: 15px 0;border-top: 1px solid #444446;border-bottom: 1px solid #ebebeb;font-size: 20px;'>");
      textTemp = textTemp.replace(/\s*<\/pre[^>]*>/g, "</pre>");
      textTemp = textTemp.replace(/<\/blockquote>\s*<blockquote[^>]*>/g, "<br>");
      textTemp = textTemp.replace(/<\/h1>\s*<h1[^>]*>/g, "<br>");
      textTemp = textTemp.replace(/<\/h2>\s*<h2[^>]*>/g, "<br>");
      textTemp = textTemp.replace(/<\/h3>\s*<h3[^>]*>/g, "<br>");
      textTemp = textTemp.replace(/<\/h4>\s*<h4[^>]*>/g, "<br>");
      // tmp2 = textTemp.match(/<\/blockquote><blockquote>/g);
      // if(tmp2){
      //   for(var j in tmp2){
      //     textTemp = textTemp.replace(tmp2[j], "<br>");
      //   }
      // }
      tmp2 = textTemp.match(/<iframe.*?>(.*?)<\/iframe>/g)
      if(tmp2){
        console.log('iframe: ', tmp2)
        for(var j in tmp2){
          let matchData = tmp2[j].match(/(src=")([^"]*(autoPlay=true))(")/);
          console.log("match: ", matchData)
          if(matchData && matchData[3]){
            textTemp = textTemp.replace(tmp2[j], tmp2[j].replace('src=', 'style="max-width:100%; width: 640px; height: 360px; display: block; margin: 0 auto;" src=').replace(/(autoPlay=true)/g, "").replace(/(src=")([^"]*)(")/, '$1$2&autoplay=1&mute=1$3'))
            // textTemp = textTemp.replace(tmp2[j], tmp2[j].replace('src=', 'style="max-width:100%; width: 640px; height: 360px;" src=').replace(/autoPlay=false/, 'autoPlay=true'));
          }else if(tmp2[j].match(/\?/)){
            textTemp = textTemp.replace(tmp2[j], tmp2[j].replace('src=', 'style="max-width:100%; width: 640px; height: 360px; display: block; margin: 0 auto;" src=').replace(/(src=")([^"]*)(")/, '$1$2&autoplay=1&mute=1$3'));
          }else{
            textTemp = textTemp.replace(tmp2[j], tmp2[j].replace('src=', 'style="max-width:100%; width: 640px; height: 360px; display: block; margin: 0 auto;" src=').replace(/(src=")([^"]*)(")/, '$1$2?autoplay=1&mute=1$3'));
          }
          // textTemp = textTemp.replace(tmp2[j], tmp2[j].slice(0, tmp2[j].indexOf('src=')) + `style="max-width:100%; width: 640px; height: 360px;" ` + tmp2[j].slice(tmp2[j].indexOf('src=')));
        }
      }
      while(textTemp.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/)){
        tmp = textTemp.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/)
        console.log('imgtag: ', tmp)
        // this.sendData.arrayBase64.push(tmp[1]);
        tmp3 = tmp[0].match("display:?([^;]+)[;]")
        if(tmp3)
        {
          console.log('dddd',tmp3)
          if(tmp3[1] == ' block'){
            console.log('block')
          }else if(tmp3[1] == ' inline'){
            tmp3 = tmp[0].match("float:?([^;]+)[;]")
            console.log(tmp3[1])
          }
        }
        if(tmp3){
          if(tmp3[1] == ' block') tmp3 = "C";
          else if(tmp3[1] == ' left') tmp3 = "L";
          else if(tmp3[1] == ' right') tmp3 = "R";
        }
        else tmp3 = "C";

        console.log('result_tmp3:', tmp3)
        // this.sendData.arrayImageAlign.push(tmp3);
        tmpWidth = tmp[0].match(/width="?([^"]+)["]/)
        if(tmpWidth){
          if(tmpWidth[1] > this.$store.state.maxWidth) tmpWidth = this.$store.state.maxWidth;
          else tmpWidth = tmpWidth[1];
        }else tmpWidth = "";
        // this.sendData.arrayImageWidth.push(tmpWidth);

        var imgTag = '<@IMG'+i+'>';
        var tmpCaption = '';
        textTemp = textTemp.replace(tmp[0],imgTag);
        tmp4 = textTemp.match(imgTag+"(<span class=\"ql-cursor\">\uFEFF</span>)?(</p><p[^>]*>)?(.*?)</p>")
        if (tmp4){
          console.log('tmp4: ', tmp4)
          if(tmp4[3].match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/)){
            console.log(tmp4[3], tmp4[3].indexOf('<img'));
            textTemp = textTemp.replace(tmp4[0].substring(0,tmp4[0].indexOf('<img')),imgTag + "</p>");
            tmpCaption = tmp4[3].substring(0,tmp4[3].indexOf('<img'));
          }else if(tmp4[3].match(/<\/a>/)) {
            textTemp = textTemp.replace(tmp4[0],imgTag + "</a>" + "</p>");
            tmpCaption = "";
          }else {
            textTemp = textTemp.replace(tmp4[0],imgTag + "</p>");
            tmpCaption = tmp4[3].replace(/<\/?([a-z]+[^>]*)>/g,'');
            // this.sendData.arrayImageText.push(tmp4[1]);
          }
        }else tmpCaption = '';//this.sendData.arrayImageText.push('');
        var pno = 0;
        var photoIndex = -1;
        console.log('this.photoData:', this.photoData)
        if((photoIndex = this.photoData.findIndex(e => tmp[1].includes(e.img))) >= 0){
          pno = this.photoData[photoIndex].pno;
        }
        console.log('pno:', pno, tmp[1])
        this.sendData.images.push({'img': tmp[1], 'img_c': tmpCaption, 'width': tmpWidth, 'align': tmp3, 'pno': pno})
        i++;
      }
      // console.log(textTemp.replace(/<\/?([a-z]+[^>]*|@IMG[^>])>/g, ""))
      this.sendData.text = textTemp.replace(/<(|p[^>]*)> ?<\/p>/g, "<p><br></p>");
      this.sendData.summary = textTemp.replace(/<\/?([a-z]+[^>]*|@IMG[^>]*)>/g, "").substr(0,300);
      if(textTemp.replace(/<\/?([a-z]+[^>]*|@IMG[^>]*)>/g, "").length > 300) this.sendData.summary += "…"
      // this.sendData.mainTitle = this.sendData.mainTitle.replace(/background-color:[^;]*;|<\/?(h[^>]*|p[^>]*|strong[^>]*)>/g, "").substring(0,99);
      this.sendData.subTitle = this.sendData.subTitle.replace(/background-color:[^;]*;/g, '').split('<p><br></p>').join('').substring(0,499);
      // console.log('mainTitle: ', this.sendData.mainTitle, 'subTitle: ', this.sendData.subTitle);
      // console.log(this.$refs.quillEditor_descr.quill.getText().substr(0,50), this.$refs.quillEditor_descr.quill.getText().length);
      // if(this.$refs.quillEditor_descr.quill.getText().length > 52) this.sendData.summary = this.$refs.quillEditor_descr.quill.getText().substr(0,51) + '…';
      // else this.sendData.summary = this.$refs.quillEditor_descr.quill.getText();
      this.descrToArticle(textTemp, this.sendData.images, this.sendData.mainTitle, this.sendData.subTitle, 
                          moment(this.sendData.d_pass).format('YYYY-MM-DD HH:mm'), moment().format('YYYY-MM-DD HH:mm'), this.sendData.byline.replace('중앙신문 =', '').replace('중앙신문 =',''), 
                          this.sendData.email, this.sendData.review_rate, (article, preview, error)=>{
        // 🔴 미리보기 생성이 인증 실패로 끝났으면 **여기서 끊는다.** 그대로 진행하면
        //    아래 검증·랭킹조회·최근기사조회가 다 돌아 401 한 번이 여러 번으로 늘어난다.
        //    (handleUnauthorized 는 descrToArticle 안에서 이미 불렸다.)
        if(error){ cb(null, null, error); return; }
        this.contentView = article;
        this.contentPreview = preview;
        // console.log('미리보기', this.contentView)
        let alertText = '';
        if(this.sendData.mainTitle == '' && this.sendData.portalTitle == ''){
          alertText += '제목, ';
        }
        if(this.sendData.category1.length < 1) alertText += '카테고리1, ';
        if(!this.category1_2Disable && this.sendData.category1_2.length < 1) alertText += '카테고리1-2, ';
        if(this.sendData.category2.length < 1) alertText += '카테고리2, ';
        if(alertText != ''){
          let alertText2 = '';
          if(alertText == '제목, ') alertText2 = '을 입력해주세요!'
          else alertText2 = '를 입력해주세요!'
          
          // this.$vs.dialog({
          //     type: 'alert',
          //     color: 'warning',
          //     title: `정보 입력 확인`,
          //     text: alertText.substring(0,alertText.length-2) + alertText2,
          // })
          alert(alertText.substring(0,alertText.length-2) + alertText2);
          this.sendButtonDisable = true;
        }else {
          this.sendButtonDisable = false;
          // if(this.sendData.rel && this.sendData.rel.length > 1){
          //   this.sendButtonDisable = false;
          // }else{
          //   this.sendButtonDisable = true;
          // }
        }
        this.getRankingNewsList();
        this.searchText = '';
        this.getNewsList('recent');
        cb(this.sendButtonDisable);
      });
    },
    // 이미지 참조를 화면에 쓸 URL 로 바꾼다. 들어오는 형태가 셋이라 한 곳에 모은다.
    //   1) https://…/tmp/123.png        방금 올린 임시 이미지(절대 URL)
    //   2) /news/photo/YYYYMM/x.jpg     저장된 본문에서 되읽은 것
    //   3) YYYYMM/x.jpg                 article_photo.filepath (DB 형식)
    // 실제 파일은 news/photo/YYYYMM/ 아래에 있다 — 3) 은 photo/ 를 붙여야 한다.
    imgUrl(img){ return imageUrl(img); },
    // 본문 이미지에서 만들어진 썸네일 URL. 서버가 news/thumbnail/YYYYMM/{base}_{w}.jpg
    // 로 150·300·500·640 을 만들어 둔다(writeArticles.js 의 THUMB_SIZES).
    // 옛 icon(_c/_c2/_c3)은 데일리안 시절 규격이라 쓰지 않는다.
    thumbUrl(img, w, v){ return thumbnailUrl(img, w, v); },
    descrToArticle(descr, imgOption, mainTitle, subTitle, d_pass, d_modi, name, email, review_rate, cb){
      this.$vs.loading({
        scale: 1.5
      });
      console.log('텍스트: ',descr)
      const thisIns = this;
      var root="/news/";
      const maxWidth = this.$store.state.maxWidth;
      let sqareThumbnail = this.sendData.category1.findIndex(e => e.code == 11);
      // if(this.thumbnailFlg){
      //   this.sendData.thumbnail = sqareThumbnail + ';' + this.thumbnail + ';' + this.thumbnailOption + ';' + this.thumbnailImageNum;
      // }else{
      //   this.sendData.thumbnail = sqareThumbnail + ';;';
      // }
      if(this.thumbnailFlg){
        this.sendData.thumbnail = this.thumbnail2 + ';' + this.thumbnail + ';' + this.thumbnailOption + ';' + this.thumbnailImageNum;
      }else{
        this.sendData.thumbnail = this.thumbnail2 + ';;;';
      }
      this.activeUserInfo.watermark = this.sendData.watermark;
      console.log('sqareThumbnail:', sqareThumbnail, this.sendData.thumbnail)
      this.$http.post('/api/writeArticles/preview', {'id': this.sendData.id, 'images': imgOption, 'thumbnail': this.sendData.thumbnail, 'watermark': this.sendData.watermark, 'wartermarkImageNum': this.watermarkImageNum, 'tag': this.sendData.tag })
        .then(function (data) {
          console.log(data)
          thisIns.newsDetailModalActive = true;
          // thisIns.newsRelList = [];
          // for(const tag of data.data.tags){
          //   thisIns.newsRelList.push({id: tag.id, b_sbj: tag.b_sbj});
          // }
          let thumbnailImageNum = parseInt(thisIns.thumbnailImageNum);
          if(!thumbnailImageNum || thumbnailImageNum > imgOption.length) { thumbnailImageNum = 1; }
          thisIns.newsRelList = data.data.tags;
          // console.log(thisIns.newsRelList)
          if(!thisIns.sendData.rel.length){ thisIns.sendData.rel = thisIns.newsRelList.slice(0,5); }
          else{ 
            for(var i in thisIns.sendData.rel){
              let tmpRel = thisIns.newsRelList.findIndex(e => e.id == thisIns.sendData.rel[i].id);
              if( tmpRel > -1 ){
                thisIns.sendData.rel[i] = thisIns.newsRelList[tmpRel];
              }
            }
          }
          // var rel_news = thisIns.newsRelList.slice(0,5);
          thisIns.sendData.images = data.data.images;
          imgOption = data.data.images;
          // 🔴 **자름 설정을 켠 채 미리보기를 누르면 그 설정대로 썸네일을 만들어 보여 준다.**
          //    썸네일은 원래 저장할 때만 만들어져서, 슬라이더를 움직이고 미리보기를 눌러도
          //    지난번 저장 때의 그림이 나왔다(2026-09-29 지적).
          //    서버는 발행본을 덮지 않고 `thumbnail/preview/{키}_…` 에 따로 만든다.
          //    만드는 함수는 저장 때와 같은 것이라 결과도 같다.
          //    응답이 늦어도 미리보기는 이미 떠 있으므로, 오면 그때 src 만 갈아 끼운다.
          if(thisIns.thumbnailFlg){
            thisIns.$http.post('/api/writeArticles/previewThumb', {
              id: thisIns.sendData.id,
              images: data.data.images,
              thumbnail: thisIns.sendData.thumbnail,
            }).then(function (r) {
              const d = (r && r.data) || {};
              const set = function (elId, rel) {
                if (!rel) return;
                const el = document.getElementById(elId);
                if (el) { el.src = imageUrl(rel); el.style.display = ''; }
              };
              set('wa-thumb-300', d.t300);
              set('wa-thumb-640', d.t640);
            }).catch(function () { /* 미리보기 썸네일은 없어도 본문 미리보기는 그대로 본다 */ });
          }
          var imgAlign = [];
          for(i=0;i<imgOption.length;i++){
            if(imgOption[i].align == 'C') imgAlign[i] = '';
            else if(imgOption[i].align == 'L') imgAlign[i] = 'margin: 0 15px; float: left;';
            else if(imgOption[i].align == 'R') imgAlign[i] = 'margin: 0 15px; float: right';
          }
          let article;
          var textTemp = "";
          let preview = "";
          if(imgOption.length){
            // thisIns.sendData.icon = imgOption[thumbnailImageNum-1].img.substring(0, imgOption[thumbnailImageNum-1].img.indexOf(`m_${thumbnailImageNum}`)) + "c.jpg"
            // 썸네일 미리보기. 옛 icon(_c/_c3)은 데일리안 규격이라 버리고
            // 새 파이프라인이 만든 news/thumbnail/... 을 그대로 보여준다.
            var _thumbSrc = imgOption[(thisIns.thumbnailImageNum || 1) - 1] || imgOption[0];
            // 🔴 **캐시를 끊어야 한다.** 썸네일 파일 이름은 규격마다 고정이라
            //    자름 설정을 바꿔 다시 만들어도 URL 이 같다. 그냥 두면 미리보기가
            //    처음 받아 둔 옛 그림을 계속 보여 줘 **"위치 설정이 안 먹는다"**로
            //    보인다(2026-09-29 지적. 실제로는 서버 파일이 정상으로 바뀌고 있었다).
            //    미리보기는 '지금 서버에 있는 것'을 봐야 하므로 매번 새로 받는다.
            var _tv = Date.now();
            var _t300 = thisIns.thumbUrl(_thumbSrc && _thumbSrc.img, 300, _tv);
            var _t640 = thisIns.thumbUrl(_thumbSrc && _thumbSrc.img, 640, _tv);
            if(_t300){
              preview = "<div style='margin-bottom: 20px;'>"
                + "<div><span style='margin-left: 100px;'>목록 썸네일 300</span><span style='margin-left: 240px;'>와이드 640</span></div>"
                + "<img id='wa-thumb-300' src='" + _t300 + "' style='width:300px; vertical-align:top;' onerror=\"this.style.display='none'\">"
                + "<img id='wa-thumb-640' src='" + _t640 + "' style='margin-left: 20px; width:400px; vertical-align:top;' onerror=\"this.style.display='none'\">"
                + "</div>";
            }
          }
          textTemp += "<h2 class='title'>" + mainTitle + "</h2><div class='information'><ul><li>입력 " 
                          + d_pass + "</li><li>수정 " + d_modi + "</li><li>" + name + "</li></ul></div><div class='article'>";
          if(subTitle){
            textTemp += "<div class='inner-subtitle'>" + subTitle + "</div>";
          }
          // 바이라인을 본문 맨 앞에 노출 (웹 렌더와 동일). [중앙신문 {지역}={기자명}기자]
          if(thisIns.sendData.byline){
            textTemp += "<p class='article-byline'>[" + thisIns.sendData.byline + "]</p>";
          }
          textTemp += descr + "</div>";
          // if(rel_news.length){
          //   textTemp += "<div class='news-rel'><h3>관련기사</h3><ul>"
          //   for(var i = 0; i<rel_news.length;i++){
          //     textTemp += "<li><a href='//www.jasm.co.kr/news/view/" + rel_news[i].id + "' target='_blank'>" + rel_news[i].b_sbj + "</li>";
          //   }
          //   textTemp += "</ul></div>";
          // }
          i = 1;
          var tmp = [];
          var tableText1 = "<div class='figure' style='width: ";
          var tableText2 = "'><img src='";
          var tableText3 = "' width='";
          var tableText4 = "px' alt='";
          var tableText5 = "'><span>";
          var tableText6 = "</span></div>";

          while (textTemp.match('<@IMG'+i+'>')){
            tmp = textTemp.match('<@IMG'+i+'>')
            if(imgOption[i-1].width > maxWidth) imgOption[i-1].width = maxWidth;
            textTemp = textTemp.replace(tmp[0],tableText1 + imgOption[i-1].width + 'px;' + imgAlign[i-1] + tableText2 
                                      + thisIns.imgUrl(imgOption[i-1].img) + tableText3 + imgOption[i-1].width 
                                      + tableText4 + tableText5
                                      + imgOption[i-1].img_c + tableText6);
            i++;
          }
          if(review_rate && review_rate.rate){
              let stars = '';
              for(i=0; i<review_rate.rate;i++){
                  if(review_rate.rate - i >= 1) stars += "★";
                  else stars += "☆";
              }
              textTemp += "<p><br></p><p>리뷰점수: " + stars + "</p>";
          }
          article = textTemp// + `<div style=" display: flex; margin: 80px 0 20px; padding: 20px 60px; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc;"><div style="height: 50px; width: 100%; background-color: aliceblue;"></div></div>`;
          console.log('생성된 미리보기: ',article)
          thisIns.$vs.loading.close(); 
          cb(article, preview);
        })
        .catch(function (error) {
          const errorText = String(error);
          // 🔴 **401 은 cb(descr) 로 이어 가면 안 된다.** 미리보기 실패를 성공으로
          //    취급하면 랭킹·최근기사 조회와 저장이 그대로 진행돼 401 한 번이
          //    네 번으로 증폭된다. 세 번째 인자로 error 를 넘겨 호출부가
          //    "인증 실패라 중단" 을 구분하게 한다(beforeRouteLeave 가 이걸 본다).
          if(thisIns.isAuthError(error)){
            thisIns.$vs.loading.close();
            thisIns.handleUnauthorized();
            cb(null, null, error);
            return;
          }
          else if(errorText.includes('415')){
            thisIns.$vs.notify({
              title:'Error',
              text: '잘못된 이미지가 포함되었습니다. 다른 이미지로 변경해주세요.',
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'})
            thisIns.$vs.loading.close();  
          }
          else{
            thisIns.$vs.notify({
              title:'Error',
              text: error,
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'})
            thisIns.$vs.loading.close();  
          }
          cb(descr);
        });
    },
    countCharacter(event) {
      const quill = event.quill || this.$refs.quillEditor_descr?.quill
      if (!quill) return

      // console.log(event.quill); //this.content.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/p><p>)?(.*?)<\/p>/))
      var lines = event.quill.getLines();
      var captionFlg = false;
      var imgIdx = 0;
      let textCount = 0;
      let limitCount = 1000;
      for(var i in lines){
        if(['H5','H6'].find(e => e == lines[i].domNode.tagName)){
          lines[i].domNode.outerHTML = `<p>${lines[i].domNode.innerHTML}</p>`;
          return;
        }
        for(var j in lines[i].domNode.childNodes){
          // if(['H3'].find(e => e == lines[i].domNode.childNodes[j].tagName)){
          //   lines[i].domNode.childNodes[j].outerHTML = `<div style="border: 4px solid #D6D6D6;padding: 20px;margin: 0 0 45px;font-size: inherit;font-weight: inherit;position: relative;"><div style="position: absolute;left: 150px;bottom: -40px;height: 40px;width: 40px;overflow: hidden;"><div style="transform: translate(-20px, -17px);"><div style="box-sizing:border-box;border-bottom: 4px solid #D6D6D6;width: 148%;height:40px;transform: rotateZ(-40deg);background-color: white;"></div></div></div>${lines[i].domNode.childNodes[j].innerHTML}</div>`;
          //   return;
          // }
          if(['H5','H6'].find(e => e == lines[i].domNode.childNodes[j].tagName)){
            lines[i].domNode.childNodes[j].outerHTML = `<p>${lines[i].domNode.childNodes[j].innerHTML}</p>`;
            return;
          }
          // if(lines[i].domNode.childNodes[j].style && lines[i].domNode.childNodes[j].style.fontSize){
          //   console.log(lines[i].domNode.childNodes[j].style.fontSize)
          // }
          // if(lines[i].domNode.childNodes[j].childNodes){
          //   for(const child of lines[i].domNode.childNodes[j].childNodes){
          //     if(child.style && child.style.fontSize){
          //       console.log(child.style.fontSize)
          //     }
          //   }
          // }
        }
        // console.log('line', i, lines[i])
        // console.log('line', i, lines[i], lines[(parseInt(i)+1)], lines[i].length())
        var _imgIdx = -1;
        for(j in lines[i].domNode.childNodes){
          if(lines[i].domNode.childNodes[j].tagName == 'IMG'){
            _imgIdx = j;
            break;
          }
        }
        // console.log("_imgIdx: ", _imgIdx, captionFlg)
        if(_imgIdx > -1){
          // if(captionFlg){
          //   lines[i].domNode.outerHTML = '<p>ⓒ</p>' + lines[i].domNode.outerHTML;
          //   event.quill.setSelection(event.quill.getSelection() + 2)
          //   return
          // }
          // if (captionFlg) {
          //   const quill = event.quill;

          //   // 1) 현재 라인의 시작 index 구하기
          //   //   - Quill.find 는 quill.constructor.find 로도 접근 가능합니다.
          //   const blot = quill.constructor.find(lines[i].domNode);
          //   const lineIndex = quill.getIndex(blot); // 라인 시작 위치

          //   // 2) 라인 앞에 'ⓒ' 한 줄 삽입 (DOM 직접 수정 금지)
          //   quill.insertText(lineIndex, `ⓒ\n`, 'user');

          //   // 3) 커서 이동 (안전 가드 포함)
          //   //    selection은 객체이므로 +2 연산이 아니라 index를 명시해야 합니다.
          //   const targetIndex = lineIndex + 2; // 'ⓒ\n' 길이만큼 뒤
          //   try {
          //     quill.setSelection(targetIndex, 0, 'user');
          //   } catch (_) {
          //     // DOM 갱신 직후라면 다음 프레임에서 재시도
          //     requestAnimationFrame(() => {
          //       try { quill.setSelection(targetIndex, 0, 'user'); } catch (_) { console.log(_)}
          //     });
          //   }

          //   return;
          // }
          lines[i].domNode.style.color = '';
          lines[i].domNode.style.textAlign = "left";
          lines[i].domNode.style.marginBottom = "";
          if(this.initImage && this.sendData.images.length){
            if(this.sendData.images[imgIdx].align == 'C') {
              lines[i].domNode.childNodes[_imgIdx].style.display = 'block';
              lines[i].domNode.childNodes[_imgIdx].style.margin = '0 auto';
            }else if(this.sendData.images[imgIdx].align == 'L') {
              lines[i].domNode.childNodes[_imgIdx].style.float = 'left';
              lines[i].domNode.childNodes[_imgIdx].style.display = 'inline';
              lines[i].domNode.childNodes[_imgIdx].style.margin = '0px 1em 1em 0px';
            }else if(this.sendData.images[imgIdx].align == 'R') {
              lines[i].domNode.childNodes[_imgIdx].style.float = 'right';
              lines[i].domNode.childNodes[_imgIdx].style.display = 'inline';
              lines[i].domNode.childNodes[_imgIdx].style.margin = '0px 1em 1em 0px';
            }
            imgIdx++;
          }
          if(!lines[i].domNode.childNodes[_imgIdx].style.float) {
            // console.log('test')
            lines[i].domNode.childNodes[_imgIdx].style.display = 'block';
            lines[i].domNode.childNodes[_imgIdx].style.margin = '0 auto';
          }
          if(_imgIdx > 0){
            var _tmpIdx = lines[i].domNode.outerHTML.indexOf('<img src');
            lines[i].domNode.outerHTML = lines[i].domNode.outerHTML.substring(0,_tmpIdx) + '</p><p>' + lines[i].domNode.outerHTML.substring(_tmpIdx);
            // console.log('inner image', 1, _imgIdx)
            return
          }else if(lines[i].domNode.childNodes.length > 1) {
            _tmpIdx = lines[i].domNode.outerHTML.indexOf(lines[i].domNode.childNodes[_imgIdx].outerHTML) + lines[i].domNode.childNodes[_imgIdx].outerHTML.length;
            lines[i].domNode.outerHTML = lines[i].domNode.outerHTML.substring(0,_tmpIdx) + '</p><p>' + lines[i].domNode.outerHTML.substring(_tmpIdx);
            // console.log('image+node', 1, _imgIdx)
            // lines[i].domNode.innerHTML = lines[i].children.head.domNode.outerHTML;
            return
          }
          else {
            // console.log("captionFlg: ",_imgIdx, lines[i].domNode, lines[i].next.domNode)
            if(i == lines.length - 1){
              lines[i].domNode.outerHTML += 'ⓒ</p>'
              return
            }
            captionFlg = true;
          }
          // if((parseInt(i)+1) < lines.length){
          //   if(lines[(parseInt(i)+1)].children){
          //     console.log('test1')
          //     if(lines[(parseInt(i)+1)].children.head.domNode.tagName != 'IMG') {
          //       console.log('test2')
          //       lines[(parseInt(i)+1)].domNode.style.textAlign = 'center';
          //       lines[(parseInt(i)+1)].domNode.style.color = '#DB2929';
          //     }
          //   }
          // }
        }
        else if(captionFlg){
          captionFlg = false;
          _imgIdx = -1;
          // console.log("caption lines: ", lines[i].domNode)
          for(j in lines[i].domNode.childNodes){
            if(lines[i].domNode.childNodes[j].tagName == 'IMG'){
              _imgIdx = j;
              break;
            }
          }
          if(_imgIdx == -1){
            lines[i].domNode.style.color = "rgb(219, 41, 41)";
            lines[i].domNode.style.textAlign = "center";
            lines[i].domNode.style.marginBottom = "30px";
            // console.log('textContent: ', lines[i].domNode.textContent, lines[i].domNode.textContent.length)
            // for(const char of lines[i].domNode.textContent){
            //   // console.log('char:', char)

            // }
            if(lines[i].domNode.textContent == ''){ 
              lines[i].domNode.outerHTML = '<p>ⓒ</p>'
              event.quill.setSelection(event.quill.getSelection())
              return
            }
          }
        }else{
          if(textCount > limitCount){
            const getNode = function(n, v) {
              n = document.createElementNS("http://www.w3.org/2000/svg", n);
              for (var p in v)
                n.setAttributeNS(null, p.replace(/[A-Z]/g, function(m) { return "-" + m.toLowerCase(); }), v[p]);
              return n
            }
            console.log('over ', limitCount, ': ', lines[i])
            lines[i].domNode.style.borderTop = '1px solid blue';
            //"<svg xmlns='http://www.w3.org/2000/svg' version='1.1'height='50px' width='120px'><text x='0' y='15' fill='red' font-size='20'>I love SVG!</text></svg>"
            let bgSvgDom = getNode("svg");
            let textSvg = getNode("text", {x: 570, y: 20, fill: 'blue', 'font-size': 20});
            textSvg.innerHTML = limitCount;
            bgSvgDom.appendChild(textSvg);
            // console.log(bgSvgDom);
            lines[i].domNode.style.background = `url("data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(bgSvgDom))}")`;
            limitCount += 500;
          }else if(lines[i].domNode.style.borderTop == '1px solid blue'){
          // }else if(lines[i].domNode.className.includes('textBackground')){
            lines[i].domNode.style.borderTop = '';
            lines[i].domNode.style.background = '';
          }
          // console.log('text: ', lines[i].domNode.textContent, lines[i].domNode.textContent.length);
          textCount += lines[i].domNode.textContent.length;
          if(lines[i].domNode.style.color == "rgb(219, 41, 41)"){
            lines[i].domNode.style.color = '';
            lines[i].domNode.style.textAlign = "left";
            lines[i].domNode.style.marginBottom = "";
          }
        }
        // if(lines[i].children.tail.domNode.tagName == 'IMG' && lines[i].children.length > 1){ 
        //   lines[i].domNode.outerHTML = '<p>' + lines[i].domNode.innerText + '</p><p>' + lines[i].children.tail.domNode.outerHTML + '</p>';
        // }
      }
      this.initImage = false;
      // for(var i in event.quill.editor.delta.ops){
      //   if(event.quill.editor.delta.ops[i].insert.image){
      //     // console.log(i)
      //     if(event.quill.editor.delta.ops[i].attributes.color == "#ff9900"){
      //       console.log(event.quill.editor.delta.ops[i].attributes)
      //       event.quill.formatText(event.quill.getText().indexOf(event.quill.editor.delta.ops[i].insert), event.quill.editor.delta.ops[i].insert.length, '')
      //     }
      //   }
      // }
      // var tmpContent = this.decodeHtmlChar(this.content.replace(/\uFEFF|<span class="ql-cursor">(\uFEFF)?<\/span>|<span style="color: rgb(219, 41, 41);"><\/span>/g, ''));
      // var tmpContent2 = this.decodeHtmlChar(this.content.replace(/\uFEFF|<span class="ql-cursor">(\uFEFF)?<\/span>|<span style="color: rgb(219, 41, 41);"><\/span>/g, ''));
      // // console.log('tmp:', tmpContent);
      // var tmp, tmp2, tmp3;
      // if(tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/g)){
      //   tmp = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/g);
      //   // console.log('tmp:', tmp);
      //   for(var i=0; i < tmp.length; i++){
      //     // var j = i;
      //     tmp2 = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/span>)?(<\/p><p[^>]*>)?(.*?)<\/p>/);
      //     [tmp2, tmpContent, i] = this.captionImageCheck1(tmp2, tmpContent, i)
      //     console.log('tmp2: ', tmp2, i)
      //     if(tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g,'').length == 0){
      //       // console.log(tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g,'')[0])
      //       // console.log('set selection: ', event.quill.getSelection())
      //       event.quill.insertText(tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])).replace(/<\/p><p[^>]*>|&nbsp;|&amp;/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length + parseInt(i) + 1, ' ')
            
      //       // if(!event.quill.getSelection().index) event.quill.insertText(event.quill.getSelection() + 1, ' ')
      //       // else event.quill.insertText(event.quill.getSelection(), ' ')
      //       // if(tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g,'')[0].match(/ㅂ|ㅃ|ㅈ|ㅉ|ㄷ|ㄸ|ㄱ|ㄲ|ㅅ|ㅆ|ㅁ|ㄴ|ㅇ|ㄹ|ㅋ|ㅌ|ㅊ|ㅍ|ㅎ/)){
      //         //  this.content = this.content.replace('<span style="color: rgb(255, 153, 0);">' + tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g,'')[0], '<span style="color: rgb(255, 153, 0);">')
      //       // }
      //     }
      //     if(tmp2 && tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g, "") && (!tmp2[4].includes('<span style=') || tmp2[4].includes('<span style="color: rgb(219, 41, 41);"></span>')  )&& !tmp2[4].includes('<span class="ql-cursor">')) {
      //       // console.log(event.quill.getText().substring(0, tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])).replace(/<\/p><p[^>]*>|&nbsp;|&amp;/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length + parseInt(i)), '\nasdf\n', tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])), tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])).replace(/<\/p><p[^>]*>|&nbsp;|&amp;/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length + parseInt(i) + 1, tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g, "").replace(/&amp;/g, '&').length + 1)
            
      //       event.quill.formatText(tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])).replace(/<\/p><p[^>]*>|&nbsp;|&amp;/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length + parseInt(i) + 1, 
      //                             tmp2[4].replace(/<\/?([a-z]+[^>]*)>/g, "").replace(/&amp;/g, '&').length + 1, 'color', "#DB2929", 'user');
            
      //       return
      //     }
      //     // tmp3 = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/span>)?(<\/p><p[^>]*>)?(.*?)<\/p><p[^>]*>(.*?)<\/p>/)
      //     // if(tmp3[4].includes('<img ')){
      //     //   // console.log('tmp3 img:', tmp3);
      //     //   tmp3 = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/);
      //     //   tmpContent = tmpContent.replace(tmp3[0], '');
      //     //   // console.log('tmp3 img:', tmpContent);
      //     //   tmp3 = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/span>)?(<\/p><p[^>]*>)?(.*?)<\/p><p[^>]*>(.*?)<\/p>/)
      //     //   j++;
      //     // }
      //     // if(tmp3[4] && !tmp3[5].includes('<img ') && tmp3[5].includes('<span style="color: rgb(255, 153, 0);">')) {
      //     //   console.log('tmp3:', tmp3);
      //     //   event.quill.formatText(tmpContent2.substring(0, tmpContent2.indexOf(tmp[i])).replace(/<\/p><p[^>]*>/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length + tmp[i].match(/<\/p>/g).length + parseInt(j) + tmp3[4].replace(/<\/?([a-z]+[^>]*)>/g, "").length, 
      //     //                         tmp3[5].replace(/<\/?([a-z]+[^>]*)>/g, "").length + 1, 'color', "");
      //     //   break
      //     // }
      //     tmpContent = tmpContent.replace(tmp2[0], '');
      //   }
      //   var tmpContent3 = tmpContent.match(/<span style="color: rgb\(219, 41, 41\);">(.*)?<\/span>/)
      //   // console.log(tmpContent3, tmpContent2.indexOf(tmpContent3[0]), tmpContent2.substring(0, tmpContent2.indexOf(tmpContent3[0])).replace(/<\/p><p>/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length, tmpContent3[1].replace(/<\/?([a-z]+[^>]*)>/g, "").length + 1)
      //   if(tmpContent3 && !tmpContent3[1].includes('<span class="ql-cursor">')) event.quill.formatText(tmpContent2.substring(0, tmpContent2.indexOf(tmpContent3[0])).replace(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/g, "\n").replace(/<\/p><p>|&nbsp;|&amp;/g, "\n").replace(/<\/?([a-z]+[^>]*)>/g, "").length, tmpContent3[1].replace(/<\/?([a-z]+[^>]*)>/g, "").replace(/&amp;/g, '-').length + 1, 'color', '');
      // }


      this.content = this.content.replace('<p>&lt;iframe ', '<iframe ').replace('&gt;&lt;/iframe&gt;</p>', '></iframe>').replace('?autoPlay=true', '?autoPlay=false');
      // var strValue = this.content.replace(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/p><p[^>]*>)?(.*?)<\/p>/g,"").replace(/<\/?([a-z]+[^>]*)>/g, "");//event.quill.getText().replace(/\n/g,'');
      // var strLen = strValue.length; //글자수 셈하기
      // this.textcount = strLen;
      this.textcount = textCount;
      this.papers = parseInt((this.textcount)/200);
    },
    captionImageCheck1(tmp2, tmpContent, i){
      if(tmp2 && tmp2[4].includes('<img ')){
        var tmp = tmpContent.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>/);
        // console.log('tmp2 img:', tmp);
        var tmpContent1 = tmpContent.replace(tmp[0], '');
        tmp = tmpContent1.match(/<img[^>]*src=["']?([^>"']+)["']?[^>]*>(<\/span>)?(<\/p><p[^>]*>)?(.*?)<\/p>/);
        i++;
        if(!tmp){
          console.log('return');
          return [tmp2, tmpContent, i]
        }
        [tmp, tmpContent1, i] = this.captionImageCheck1(tmp, tmpContent1, i)
        return [tmp, tmpContent1, i]
      }else return [tmp2, tmpContent, i]
    },
    decodeHtmlChar(text){
      return text.replace(/&amp;|&quot;|&lt;|&gt;|&copy;|&deg;/g, ' ')
    },
    customButtonClick(editor, text) {
      // console.log(editor)
      editor.focus();
      editor.insertText(editor.getSelection().index, text)
    },
    customButtonClick2() {
      this.relNewsModalActive = true;
      // console.log(editor)
      // editor.focus();
      // editor.in
      // editor.insertText(editor.getSelection().index, '<div class="innerRelnews"><p>관련기사</p><p></p></div>')
    },
    changeEmail(){
      // 이메일은 바이라인에 넣지 않는다(별도 필드). 바이라인만 최신 상태로 재구성.
      this.buildByline();
    },
    // 바이라인 형식: [중앙신문 {지역}={기자명}기자]
    //  - 대괄호는 저장/렌더 단계에서 감싼다. 여기서는 안쪽 문자열만 만든다.
    //  - 지역은 member.region(작성자 목록의 tail/region). 없으면 '중앙신문 =홍길동기자'.
    buildByline(){
      let w = this.writer.find(data => data.idx == this.sendData.mno);
      const active = this.$store.state.AppActiveUser;
      let region = w ? (w.region || w.tail || '') :
        (this.sendData.mno == active.id ? (active.tail || '') : '');
      let byline = '중앙신문 ' + region + '=' + this.sendData.name + '기자';
      for(var i=0;i<this.tmpWriter2.length;i++){
        if(this.tmpWriter2[i]) byline += ', ' + this.tmpWriter2[i].nickname + '기자';
      }
      this.sendData.byline = byline;
    },
    setWriter(val){
      console.log(val)
      this.sendData.mno = val.idx;
      this.sendData.name = val.nickname;
      this.sendData.tailname = val.tail ? ' ' + val.tail : '';
      // 이메일은 DB 등록값 그대로 표시한다(구 ebn→jasm 치환 잔재 제거).
      this.sendData.email = val.email || '';
      this.buildByline();
    },
    setWriter2(val){
      // console.log(val)
      if(val.length > 10){
        alert('최대 10명까지 입력 가능합니다.')
        this.tmpWriter2.splice(10);
      }
      // console.log('tmpWriter2: ',this.tmpWriter2)
      this.sendData.another_writer = '';
      for(var i=0;i<this.tmpWriter2.length;i++){
        if(this.tmpWriter2[i]) {
          this.sendData.another_writer += this.tmpWriter2[i].idx + ';';
        }
      }
      this.buildByline();
      // document.querySelector('.ql-customMacro').value = this.sendData.byline;
      console.log('another_writer: ',this.sendData.another_writer)
    },
    setCategory1(val){
      // 🔴 **중복 설정을 허용한다**(수정안 5번). 예전에는 여기서 마지막 하나만
      //    남겨 사실상 단일 선택이었다. 저장부(writeArticles.js editNews)는 원래
      //    배열을 전부 돌며 INSERT 하고 article_section 도 1:N 이라 프런트만 풀면 된다.
      // 🔴 인자 없이 불리는 곳이 있다(연합뉴스 수신함 import). 그때 아래에서
      //    val.forEach 가 터지므로 여기서 현재 값으로 메운다.
      if(val === undefined) val = this.sendData.category1;
      if(!val) val = [];
      // '전체'만 배타다 — '전체'는 "카테고리1 없음"이라 다른 값과 같이 둘 수 없다.
      if(val.length > 1 && val.some(isAllCategory1)){
        const last = val[val.length - 1];
        val = isAllCategory1(last)
                ? [last]                              // 전체를 새로 골랐다 → 전체만
                : val.filter(c => !isAllCategory1(c)); // 다른 걸 골랐다 → 전체를 뺀다
        this.sendData.category1 = val;
      }
      // '전체' 를 고르면 카테고리1-2 는 건너뛰고 카테고리2 로 바로 간다(수정안 6번).
      // 1-2 를 비활성으로 두면 저장 검증도 1-2 를 요구하지 않는다(미리보기 validation).
      if(val.length && isAllCategory1(val[0])){
        this.sendData.category1_2 = [];
        this.categories1_2_view = [];
        this.category1_2Disable = true;
        this.sendData.type = "1";
        // 포커스를 카테고리2 로 옮겨 준다 — '자동으로 넘어감'.
        this.$nextTick(() => {
          const el = this.$refs.category2Select;
          const input = el && el.$el && el.$el.querySelector('input');
          if (input) input.focus();
        });
        return;
      }
      // 포토 선택 시 포토 타입 전환
      const photoSection = this.categories1.find(e => e.name === '포토');
      const photoCode = photoSection ? photoSection.code : -1;
      if(val && val.find(e => e.code == photoCode)){
        this.sendData.type = "9";
      } else {
        this.sendData.type = "1";
        if(this.sendData.state.code > 8){ this.states = this.$store.state.states.slice(0,2); }
      }
      // 부모에서 빠진 하위는 버린다.
      // 🔴 예전에는 `val.forEach` 안에서 지워서 **부모가 0개면 루프가 안 돌아
      //    고아 하위가 그대로 남았다.** 부모 코드 집합으로 한 번에 거른다.
      var parent1 = val.map(c => c && c.code);
      this.sendData.category1_2 = this.sendData.category1_2.filter(
        c => c && parent1.indexOf(c.first_id) > -1);
      // 카테고리1-2 뷰 갱신
      this.categories1_2_view = [];
      for(var i=0;i<val.length;i++){
        this.categories1_2_view = this.categories1_2_view.concat(this.categories1_2.filter(category => category.first_id == val[i].code));
      }
      if(this.categories1_2_view.length) this.category1_2Disable = false;
      else this.category1_2Disable = true;
      this.sendButtonDisable = !(val.length);
      this.seriesArray = this.$store.state.series.filter(e => e.category1 == 0 || val.findIndex(e2 => e2.code == e.category1) > -1);
    },
    // 카테고리1-2 · 2-2 도 중복 설정을 허용한다(수정안 5번). 예전에는 둘 다
    // 마지막 하나만 남겼다. 후보 목록(categories1_2_view / 2_2_view)은 선택된
    // 부모들의 하위를 이미 합쳐서 준다.
    setCategory1_2(val){},
    setCategory2_2(val){},
    setCategory2(val){
      // 🔴 **중복 설정을 허용한다**(수정안 5번 "중복설정 가능하게").
      //    예전에는 여기서 val = [마지막 하나] 로 잘라 사실상 단일 선택이었다.
      //    저장부(writeArticles.js)는 원래 category2 를 배열로 돌며 INSERT 하므로
      //    프런트에서 자르던 것만 풀면 된다. 카테고리2-2 는 선택된 부모들의 하위가
      //    모두 후보로 합쳐진다(아래 categories2_2_view 갱신 로직이 이미 그렇다).
      if(val === undefined) val = this.sendData.category2;
      if(!val) val = [];
      // 부모에서 빠진 하위는 버린다(setCategory1 과 같은 이유로 집합 비교).
      var parent2 = val.map(c => c && c.code);
      this.sendData.category2_2 = this.sendData.category2_2.filter(
        c => c && parent2.indexOf(c.first_id) > -1);
      // 카테고리2-2 뷰 갱신
      this.categories2_2_view = [];
      for(var i=0;i<val.length;i++){
        this.categories2_2_view = this.categories2_2_view.concat(this.categories2_2.filter(category => category.first_id == val[i].code));
      }
      if(this.categories2_2_view.length) this.category2_2Disable = false;
      else this.category2_2Disable = true;

      if(this.sendData.category2.findIndex(e => e.code == 509 || e.code == 608) > -1){
        this.reviewDisable = false;
      }else{
        this.sendData.review_rate = {'rate': ''};
        this.reviewDisable = true;
      }
      if(this.sendData.category2.findIndex(e => e.code == 1007 || e.code == 1008) > -1){
        this.sendData.photoType = "2";
      }else{
        this.sendData.photoType = "1";
      }
    },
    setSeries(val){
      // console.log("series:", val)
      // 🔴 여기 있던 자동 카테고리 지정은 **데일리안 잔재**라 지웠다(2026-09-28).
      //    시리즈 id 129/82/116/121 은 중앙신문 series 에 없고, 넣으려던 섹션도
      //    중앙신문에서는 id 1 = 정치(카테고리2 쪽) · id 106 = 연예(2단계) 라
      //    categories1/categories2 목록에 **없다**. find 가 undefined 를 돌려주고
      //    그게 배열에 들어가 다음 setCategory1 에서 터졌다.
      //    시리즈에 따른 카테고리 자동 지정이 필요하면 섹션표를 받아 다시 짠다.
      void val;
    },
    photoCheck(e){
      // console.log('photo check', e)
      // 🔴 데일리안 잔재였다 — `categories1[9]` 는 **없는 인덱스**이고('전체'+7개=8개)
      //    `code != 10` 은 포토가 아니라 **오피니언**이다(중앙신문 포토는 11).
      //    undefined 가 들어가면 setCategory1 이 val[0].code 에서 터졌다.
      //    id 를 박지 말고 이름으로 찾는다 — 위 setCategory1 의 포토 판정과 같은 방식.
      // 🔴 덮어쓰지 않고 **더하고 뺀다.** 네 칸이 다중 선택이 된 뒤로는
      //    `= [photo]` 로 덮으면 기자가 고른 다른 카테고리가 말없이 날아간다.
      const photo = this.categories1.find(c => c.name === '포토');
      if(e == 'on'){
        if(photo && !this.sendData.category1.find(c => c.code == photo.code)){
          this.sendData.category1 = this.sendData.category1.concat([photo]);
        }
        this.setCategory1(this.sendData.category1);
      }else{
        if(photo) this.sendData.category1 = this.sendData.category1.filter(c => c.code != photo.code);
        this.setCategory1(this.sendData.category1);
        const customSpecialPickerItems3 = Array.prototype.slice.call(document.querySelectorAll('#toolbar3 .ql-customSpecial .ql-picker-item'));
        customSpecialPickerItems3.forEach(item => item.textContent = item.dataset.value);
        document.querySelector('#toolbar3 .ql-customSpecial .ql-picker-label').innerHTML
            = '특수문자' + document.querySelector('#toolbar3 .ql-customSpecial .ql-picker-label').innerHTML;
      }
    },
    watermarkToggle(e){
      // console.log(e)
      if(e.value) { this.sendData.watermark = this.activeUserInfo.watermark }
      else { this.sendData.watermark = ''; }
    },
    // addFile / submitFiles(수동 썸네일 업로드)는 2026-09-04 에 제거했다.
    // 서버 /api/writeArticles/thumbnailUpload 이 아이콘 크롭(_c/_c2)만 만들고
    // 응답조차 보내지 않는 죽은 경로였고, 이걸 부르던 파일 입력(440행)도
    // 이미 주석 처리돼 있었다. 목록 썸네일은 저장 시 서버가 자동 생성한다.
    created() {
      
      // const root = "https://cdn.jasm.co.kr/news/";
      // console.log(this.$store.state.states, this.$store.state.maxWidth)
      this.sendData.mainTitle = "";
      this.sendData.subTitle = "";
      this.sendData.state = this.$store.state.states.find(e => e.code == 9);
      this.pastState = "9";
      this.sendData.site = false;
      this.states = this.$store.state.states.slice(0,2);
      this.sendData.type = "1";
      this.sendData.category1 = [];
      this.sendData.category2 = [];
      // 🔴 하위 둘도 비워야 한다. 아래 로드 루프가 push 만 하므로 초기화하지 않으면
      //    기사를 바꿔 열 때 **이전 기사의 하위 카테고리가 누적된다**(2026-09-28).
      this.sendData.category1_2 = [];
      this.sendData.category2_2 = [];
      this.sendData.review_rate = {'rate': ''};
      this.sendData.series = null;
      // this.sendData.series = [];
      this.sendData.images = [];
      // this.sendData.arrayBase64 = [];
      // this.sendData.arrayImageAlign = [];
      // this.sendData.arrayImageText = [];
      // this.sendData.arrayImageWidth = [];
      this.sendData.tag = [];
      this.content = "";
      this.sendData.out_site = "";
      this.sendData.mno = this.$store.state.AppActiveUser.id;
      this.tmpWriter = this.writer.find(data => data.idx == this.sendData.mno);
      this.sendData.writer = this.$store.state.AppActiveUser.id;
      this.sendData.another_writer = '';
      this.tmpWriter2 = [];
      this.sendData.name = this.$store.state.AppActiveUser.name;
      this.sendData.tailname = this.$store.state.AppActiveUser.tail;
      if(this.$store.state.AppActiveUser.email) { this.sendData.email = this.$store.state.AppActiveUser.email.replace('@ebn.co.kr', '@jasm.co.kr'); }
      else {this.sendData.email = '';}
      // 신규 작성도 작성자 변경과 같은 생성 경로를 사용한다.
      this.buildByline();
      this.sendData.d_pass = new Date();
      // sns 는 화면에서 입력하지 않는다(페이스북·트위터 문구 항목 삭제, 2026-09-04).
      // 서버의 [SNS AUTO] 가 article.sns 를 읽고 결과를 다시 쓰므로 필드 자체는 왕복시킨다.
      this.sendData.sns = {};
      this.news_rel = "";
      // console.log('query id:' + this.$route.query.id, this.sendData.writer);
      const thisIns = this;
      this.$vs.loading({
        scale: 1.5
      });
      if(this.$route.query.id){
        this.sendData.id = this.$route.query.id;
            thisIns.$http.post('/api/getSingleNews', thisIns.$route.query)
              .then(function (response) {
                console.log('get news', response);
                if(response.data.deadDocument) {
                  return safeBack();
                }

                if(thisIns.sendData.mno != response.data[0][0].mno && thisIns.$store.state.AppActiveUser.level < 8 && !( response.data[0][0].option1 == thisIns.$store.state.AppActiveUser.department && thisIns.$store.state.AppActiveUser.permission.departmentEdit)){
                  alert('작성자가 아닙니다!');
                  thisIns.autoSaveFlg = false;
                  thisIns.lockFlg = false;
                  safeBack();
                }
                thisIns.sendData.mainTitle = response.data[0][0].b_sbj.replace(/<\/?(h[^>]*|p[^>]*|div[^>]*)>/g, "");
                thisIns.sendData.portalTitle = response.data[0][0].bp_sbj.replace(/<\/?(h[^>]*|p[^>]*|div[^>]*)>/g, "");
                thisIns.sendData.subTitle = response.data[0][0].s_sbj.replace(/<\/?(h[^>]*|span[^>]*|div[^>]*|strong[^>]*)>/g, "");
                thisIns.sendData.mno = response.data[0][0].mno;
                thisIns.tmpWriter = thisIns.writer.find(data => data.idx == thisIns.sendData.mno);
                if(thisIns.tmpWriter) {
                  thisIns.setWriter(thisIns.tmpWriter);
                  thisIns.sendData.name = thisIns.tmpWriter.nickname;
                  thisIns.sendData.tailname = thisIns.tmpWriter.tail ? thisIns.tmpWriter.tail : '' ;
                }else {
                  thisIns.sendData.name = response.data[0][0].name;
                }
                console.log(thisIns.sendData.name)
                // thisIns.sendData.writer = response.data[0][0].mno;
                thisIns.sendData.another_writer = response.data[0][0].another_writer;
                // console.log(thisIns.sendData.another_writer.split(';'));
                if(thisIns.sendData.another_writer){
                  thisIns.sendData.another_writer.split(';').forEach(data =>{
                    if(data)
                    thisIns.tmpWriter2.push(thisIns.writer.find(_data => _data.idx == data))
                  });
                }
                thisIns.setWriter2(thisIns.tmpWriter2);
                if(response.data[0][0].email){
                  thisIns.sendData.email = response.data[0][0].email.replace('@ebn.co.kr', '@jasm.co.kr');
                }else {
                  thisIns.sendData.email = '';
                }

                // 삭제(-1/-2) 등 목록에 없는 상태면 폴백. (없으면 .code 접근에서 크래시)
                thisIns.sendData.state = thisIns.$store.state.states.find(e => e.code == response.data[0][0].state)
                    || { code: String(response.data[0][0].state), name: (response.data[0][0].state < 0 ? '삭제' : '기타') };
                thisIns.pastState = response.data[0][0].state;
                // 기사상태 목록. 🔴 예전에는 첫 줄에 `else` 가 없어서 **어떤 상태로
                //    열든 바로 아래 else 가 다시 돌아 5개를 전부 덮었다**
                //    (`'9' == 1` 이 false 라 else 가 무조건 실행된다).
                //    연합뉴스 기사화는 작성중(9)으로 초안을 만들고 ?id= 로 되돌아오므로
                //    딱 이 경로를 탔다 — 2026-09-29 "기사 상태가 전부 노출" 지적.
                //    ⚠ **기준은 `> 8`, 즉 작성중(9) 뿐이다.** 작성완료(8)에서는
                //      송고예약·송고완료·보류를 고를 수 있어야 한다(2026-09-29 지적).
                //      한때 `>= 8` 로 넓혔다가 작성완료에서 그 셋이 사라졌다.
                //    정리하면 — 작성중: 작성중/작성완료 · 송고완료: 송고완료/보류 ·
                //             작성완료·송고예약·보류: 전체(송고예약 먼저).
                if(thisIns.sendData.state.code > 8) thisIns.states = thisIns.$store.state.states.slice(0,2);
                else if(thisIns.sendData.state.code == 1) thisIns.states = thisIns.$store.state.states.filter(e => e.code == 1 || e.code == 0);
                else {
                  thisIns.states = thisIns.$store.state.states;
                  thisIns.states = [thisIns.states.find(e => e.code == 2)].concat(thisIns.states.filter(e => e.code != 2));
                }
                if(response.data[0][0].site == 'Y') thisIns.sendData.site = true;
                else thisIns.sendData.site = false;
                // console.log('site: ' + thisIns.sendData.site, response.data[0][0].site);
                thisIns.sendData.type = response.data[0][0].type_code;
                // 카테고리1 로드
                for(var i=0; i < response.data[4].length; i++){
                  let found = thisIns.categories1.find(data => data.code == response.data[4][i].code);
                  if(found) thisIns.sendData.category1.push(found);
                }
                // 🔴 **비어 있으면 '전체'로 되살린다.** '전체'는 화면에만 있는 값이라
                //    이관 기사 44,299건은 group1/level1 섹션이 아예 없어 카테고리1 이
                //    빈 칸이 되고, 미리보기 검증이 '카테고리1를 입력해주세요'로 막아
                //    **기자가 또 고르게** 만들었다(2026-09-28 지적).
                //    '전체' = "카테고리1 없음" 이므로 빈 상태의 올바른 표시다.
                //    이제 '전체'는 실제 섹션이라 그대로 저장되어 다음부터는 안 비어 있다.
                // 🔴 **한 번이라도 저장된 기사에만** 되살린다. 빈 초안(막 만든 새 기사)은
                //    섹션이 하나도 없으므로 예전처럼 빈 칸으로 두고 기자가 고르게 한다 —
                //    새 기사에 '전체'를 미리 박아 두면 아무 생각 없이 넘어가게 된다.
                if(!thisIns.sendData.category1.length
                   && (response.data[5].length || response.data[6].length || response.data[7].length)){
                  const all = thisIns.categories1.find(isAllCategory1);
                  if (all) thisIns.sendData.category1 = [all];
                }
                // 카테고리1-2 로드
                for(i=0; i < response.data[5].length; i++){
                  let found = thisIns.categories1_2.find(data => data.code == response.data[5][i].code);
                  if(found) thisIns.sendData.category1_2.push(found);
                }
                // 카테고리2 로드
                for(i=0; i < response.data[6].length; i++){
                  let found = thisIns.categories2.find(data => data.code == response.data[6][i].code);
                  if(found) thisIns.sendData.category2.push(found);
                }
                // 카테고리2-2 로드
                for(i=0; i < response.data[7].length; i++){
                  let found = thisIns.categories2_2.find(data => data.code == response.data[7][i].code);
                  if(found) thisIns.sendData.category2_2.push(found);
                }

                thisIns.sendData.series = thisIns.seriesArray.find(e => e.code == response.data[0][0].series);

                if(response.data[8].length){
                  thisIns.sendData.rel = response.data[8];
                  thisIns.tmp_rel = response.data[8];
                  thisIns.news_rel = "<h3>관련기사</h3><ul>"
                  for(i=0; i < response.data[8].length; i++){
                    thisIns.news_rel += "<li>" + response.data[8][i].b_sbj + "</li>"
                  }
                  thisIns.news_rel += "</ul>"
                }
                thisIns.photoSetArray = response.data[10] || [];
                thisIns.sendData.photoSet = thisIns.photoSetArray.find(e => e.psId == response.data[0][0].photoSet);
                if(thisIns.sendData.photoSet){
                  thisIns.sendData.photoType = thisIns.sendData.photoSet.photoType
                  thisIns.sendData.photoType2 = thisIns.sendData.photoSet.photoType2
                }

                // 카테고리1 form 상태 복원
                for(var idx in thisIns.sendData.category1) {
                  let inputIdx = thisIns.categories1.indexOf(thisIns.sendData.category1[idx])
                  thisIns.form.data.category1.categories[inputIdx] = true
                  if(thisIns.form.data.category1.toString == "카테고리1 선택") {
                    thisIns.form.data.category1.toString = thisIns.sendData.category1[idx].name
                  } else {
                    thisIns.form.data.category1.toString += `, ${thisIns.sendData.category1[idx].name}`
                  }
                }

                // 카테고리1-2 뷰 갱신
                thisIns.categories1_2_view = []
                for(i=0;i<thisIns.sendData.category1.length;i++){
                  thisIns.categories1_2_view = thisIns.categories1_2_view.concat(thisIns.categories1_2.filter(category => category.first_id == thisIns.sendData.category1[i].code));
                }
                if(thisIns.categories1_2_view.length) thisIns.category1_2Disable = false;

                // 카테고리2-2 뷰 갱신
                thisIns.categories2_2_view = []
                for(i=0;i<thisIns.sendData.category2.length;i++){
                  thisIns.categories2_2_view = thisIns.categories2_2_view.concat(thisIns.categories2_2.filter(category => category.first_id == thisIns.sendData.category2[i].code));
                }
                if(thisIns.categories2_2_view.length) thisIns.category2_2Disable = false;

                thisIns.setCategory1(thisIns.sendData.category1);
                thisIns.setCategory2(thisIns.sendData.category2);
                // thisIns.sendData.category1 = response.data[0][0].category1;
                // thisIns.sendData.category1.split(';').forEach((_category1)=>{
                //   if(_category1) thisIns.tmpCategory1.push(thisIns.categories1.find(data => data.code == _category1));
                // })
                // console.log('category1: ' + thisIns.sendData.category1);
                // thisIns.sendData.category2 = response.data[0][0].category2;
                // thisIns.sendData.category2.split(';').forEach((_category2)=>{
                //   if(_category2) thisIns.tmpCategory2.push(thisIns.categories2.find(data => data.code == _category2));
                // })
                thisIns.sendData.review_rate = thisIns.reviewOption.find(e => e.rate == response.data[0][0].review_rate);
                // console.log('series: ', thisIns.sendData.review_rate);
                thisIns.sendData.out_site = response.data[0][0].out_site;
                let tmpOutSite = thisIns.sendData.out_site.split("|");
                if(response.data[0][0].state != 1 && response.data[0][0].out_reserv){
                  let tmpPortal = [];
                  try {
                    tmpPortal = JSON.parse(response.data[0][0].out_reserv);
                  } catch (error) {
                    tmpPortal = [];
                    console.log(error);
                  }
                  thisIns.sendData.portalAction = tmpPortal;
                  tmpOutSite = [];
                  for(const item of tmpPortal){
                    tmpOutSite.push(item.name);
                  }
                }else{
                  for(i = 0; i<thisIns.portals.length; i++){
                    if(!thisIns.sendData.out_site){
                      thisIns.sendData.portalAction.push(JSON.parse(JSON.stringify(thisIns.portals[i])));
                    }
                    else if(tmpOutSite.find(e => e.toLowerCase() == thisIns.portals[i].name.toLowerCase() || e == thisIns.portals[i].oldName )){
                      thisIns.sendData.portalAction.push(JSON.parse(JSON.stringify(thisIns.portals[i])));
                    }
                  }
                }
                console.log('out_site: ', thisIns.sendData.portalAction);


                // 저장된 값을 그대로 되보낸다(화면에서 편집하지 않는다).
                thisIns.sendData.sns = response.data[0][0].sns || {};

                // console.log('senddata: ', thisIns.sendData)

                
                if(thisIns.sendData.state.code < 3 || response.data[0][0].d_pass > moment())
                  thisIns.sendData.d_pass = new Date(moment(response.data[0][0].d_pass));
                thisIns.sendData.images = response.data[1];
                for(i in thisIns.sendData.images){
                  const _img = thisIns.sendData.images[i];
                  if(_img.pno){
                    thisIns.photoData.push({'img': _img.img, 'pno': _img.pno});
                  }
                  // 대표 사진과 그 썸네일 자름 설정을 되살린다.
                  // article_photo 의 is_main / crop_mode / crop_position 을 그대로 읽는다.
                  // 예전에는 데일리안의 owner 컬럼(";위치;모드;" 문자열)을 파싱했는데,
                  // 중앙신문 스키마에 그 컬럼이 없어 쿼리가 '' as owner 로 빈 값을 주고 있었다.
                  // 즉 이 복원은 한 번도 동작한 적이 없고, 기사를 다시 열면 늘 기본값이었다.
                  if(Number(_img.is_main) === 1){
                    thisIns.thumbnailImageNum = Number(i) + 1;
                    if(_img.crop_mode && _img.crop_mode !== 'auto'){
                      thisIns.thumbnailFlg = true;                 // 설정 UI 를 펼친다
                      thisIns.thumbnailOption = _img.crop_mode;    // 'crop' | 'fit'
                      thisIns.thumbnail = Number(_img.crop_position);
                    }
                  }
                }
                // if(response.data[0][0].photoType){
                //   thisIns.sendData.photoType = response.data[0][0].photoType;
                // }
                // console.log('photoData: ', thisIns.photoData);
                // for(i=0;i<images.length;i++){
                //   thisIns.sendData.arrayBase64.push(images[i].img);
                //   thisIns.sendData.arrayImageText.push(images[i].img_c);
                //   thisIns.sendData.arrayImageAlign.push(images[i].align);
                //   thisIns.sendData.arrayImageWidth.push(images[i].width);
                // }
                let tags = response.data[2];
                for(i=0;i<tags.length;i++){
                  thisIns.sendData.tag.push(tags[i].tag);
                }
                let titleTags = response.data[9];
                for(i=0;i<titleTags.length;i++){
                  thisIns.sendData.titleTags.push(titleTags[i].title_tag)
                }
                if(response.data[10] && response.data[10][0]){
                  thisIns.lastArticleTime = moment(response.data[10][0].d_pass);
                }
                if(response.data[11]){
                  thisIns.forceCategoryList = response.data[11];
                }
                


                // thisIns.sendData = JSON.parse(JSON.stringify(thisIns.sendData));


                // console.log(response.data[3]);
                thisIns.lockHistory = '';
                let logs = response.data[3];
                logs.forEach(log => {
                  thisIns.lockHistory += log.name + ': ' + log.state + ' at ' + log.access_date + ' \n';
                })
                if(logs[0] && logs[0].state == 'lock' && moment(logs[0].access_date) > moment().subtract(1, 'hour') && logs[0].reporter_idx != thisIns.$store.state.AppActiveUser.id ){
                  console.log('lock: ', logs[0].reporter_idx, thisIns.$store.state.AppActiveUser.id)
                  if(thisIns.$store.state.AppActiveUser.permission.delete){
                    alert(`${logs[0].name}기자가 수정중입니다. \n동시에 수정할 경우 둘중 한쪽의 수정사항이 \n적용되지 않을 수 있습니다.\n` + parseInt((moment(logs[0].access_date) - moment().subtract(1, 'hour')) / 1000 / 60  + 1) + '분 남음' )
                    thisIns.previewDisable = false;
                  }else{
                    alert('잠겨있는 기사입니다. 수정할 수 없습니다. ' + `\n${logs[0].name}기자가 수정중입니다.` + parseInt((moment(logs[0].access_date) - moment().subtract(1, 'hour')) / 1000 / 60  + 1) + '분 남음' )
                    thisIns.autoSaveFlg = false;
                    thisIns.lockFlg = false;
                    thisIns.previewDisable = true;
                  }
                }else{
                  thisIns.previewDisable = false;
                  thisIns.$http.post('/api/writeArticles/lock', {id: thisIns.sendData.id, name: thisIns.$store.state.AppActiveUser.name, mno: thisIns.$store.state.AppActiveUser.id, lock: 'lock'})
                    .then(function (response) {
                      console.log(response);
                      thisIns.lockHistory = thisIns.$store.state.AppActiveUser.name + ': lock at ' + moment().format('YYYY-MM-DD HH:mm:ss') + ' \n' + thisIns.lockHistory;
                    })
                    .catch(function (error) {
                      console.log(error);
                      thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                      thisIns.$vs.loading.close();  
                    });
                }
                // console.log(logs[0].state, logs[0].access_date,logs[0].reporter_idx, thisIns.$store.state.AppActiveUser.id )
                thisIns.content = thisIns.loadData(response.data[0][0].descr);
                thisIns.sendButtonDisable = true;
                // thisIns.contentView = thisIns.descrToArticle(response.data[0][0].descr, [thisIns.sendData.arrayBase64, thisIns.sendData.arrayImageAlign, thisIns.sendData.arrayImageText, thisIns.sendData.arrayImageWidth]);
                // console.log(response.data, moment(response.data[0][0].d_pass).format('YYYY-MM-DD HH:mm'));
                if(response.data[0][0].byline) { thisIns.sendData.byline = response.data[0][0].byline }
                thisIns.$http.post('/api/getNewsList/photo', {'startRow': 0, 
                                                              'itemsPerPage': 50000, 
                                                              'state': null,
                                                              'category1': null,
                                                              'writer': null,
                                                              'searchText': '',
                                                              'startDate': moment().subtract(2, 'week'),
                                                              'endDate': moment()
                                                              })
                  .then(function (response) {
                    console.log('response_response)', response)
                    for(var i in response.data[1]){
                      thisIns.photoData.push({'img': response.data[1][i].mimg, 'pno': response.data[1][i].pno});
                    }
                  })
                  .catch(function (error) {
                    thisIns.$vs.notify({
                      title:'Error',
                      text: error,
                      color:'danger',
                      iconPack: 'feather',
                      icon:'icon-alert-circle'})
                    thisIns.$vs.loading.close();  
                  });

                // ?pno= 진입(사진DB → 기사작성)은 2026-09-06 에 걷어냈다.
                // /api/writeArticles/photo 가 데일리안 `photo` 테이블을 읽었는데
                // 중앙신문 스키마에 없어 늘 500 이었고, 진입로였던 /photoDB 화면도 삭제했다.
                thisIns.$vs.loading.close();
              })
              .catch(function (error) {
                console.log(error);
                thisIns.$vs.notify({
                  title:'Error',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
                thisIns.$vs.loading.close();  
              });
      }
      // 통신사 수신함(연합뉴스)에서 넘어온 경우. ?id= 와 달리 **새 기사**다 —
      // sendData.id 를 세우지 않으므로 평소의 신규 작성 흐름을 그대로 탄다.
      // 제목·본문·카테고리만 미리 채우고 작성자·바이라인은 로그인한 기자 기본값이다.
      // 먼저 채운 뒤에 초안을 만들어야 리다이렉트(?id=) 후 다시 읽어도 남아 있다.
      else if(this.$route.query.wire){
        const thisIns = this;
        this.$http.post('/api/wire/get', {id: this.$route.query.wire})
          .then(function (res) {
            const w = (res.data && res.data.data) || {};
            // 🔴 서버는 원문 조회에 실패해도 `bodyError` 만 실어 **200 으로** 돌려준다
            //    (lib/wire.js getWithBody 가 cb(null,row) 로 성공 취급). 그걸 안 보고
            //    진행해서 **본문이 빈 초안이 만들어지고 수신함에는 '작성됨' 으로 찍혀**
            //    재시도조차 막혔다(2026-09-28). 여기서 끊는다.
            if (res.data && res.data.bodyError) {
              // 🔴 **빈 초안을 만들지 않는다.** createDraft(null) 을 부르면 내용 없는
              //    기사가 뉴스리스트에 '작성중' 으로 남는다. 수신함으로 돌려보내
              //    다시 시도하게 한다(markUsed 를 안 불렀으니 그 기사는 그대로 있다).
              thisIns.$vs.notify({title:'연합뉴스', text:'원문을 가져오지 못했습니다. 잠시 후 다시 시도해 주세요.',
                color:'danger', iconPack:'feather', icon:'icon-alert-circle'});
              thisIns.$vs.loading.close();
              thisIns.$router.push({path: '/wireList'});
              return;
            }
            thisIns.sendData.mainTitle = w.title || '';
            // write_content 는 앞머리 바이라인("(세종=연합뉴스) 이세원 기자 = ")을 뗀 것이다.
            // 미리보기는 원문 그대로 보여 주므로 content 와 다르다.
            const paras = (w.write_content || w.content || '').split('\n\n');
            thisIns.sendData.id = '';
            // 카테고리는 section.id 로 맞춘다(서버가 code→id 변환해 준다).
            // 🔴 예전에는 `categories1` 에서만 찾았다. 그런데 피드→섹션 매핑
            //    (config/wireConfig.js)에서 **`categories1`(지역·오피니언·포토…)에
            //    있는 것은 지역(S1N5) 하나뿐**이고 나머지 9개 피드는 전부
            //    `categories2`(정치·경제·사회…) 쪽이다. 그래서
            //      - 지역 기사: 찾긴 찾는데 setCategory1() 을 **인자 없이** 불러
            //        TypeError → .catch 로 떨어져 **변환 자체가 실패**했다(수신함의 29%).
            //      - 나머지 기사: 못 찾아서 카테고리가 아예 안 채워졌다.
            //    두 목록을 다 뒤지고 각자 맞는 칸에 넣는다. 인자도 넘긴다.
            if(w.section_id){
              const wid = String(w.section_id);
              const hit1 = thisIns.categories1.find(function(c){ return String(c.code) === wid; });
              const hit2 = thisIns.categories2.find(function(c){ return String(c.code) === wid; });
              if(hit1){ thisIns.sendData.category1 = [hit1]; thisIns.setCategory1(thisIns.sendData.category1); }
              if(hit2){ thisIns.sendData.category2 = [hit2]; thisIns.setCategory2(thisIns.sendData.category2); }
            }
            // 본문의 [[IMG:n]] 을 사진으로 바꾼다 — 연합뉴스 원문과 같은 위치에 들어간다.
            // 서버가 사진을 우리 임시폴더로 받아 둔 뒤 우리 URL 을 준다(index 로 짝을 맞춘다).
            // <img> + 캡션 <p> 형태면 저장 로직이 평소처럼 article_photo 로 뽑아낸다.
            const buildBody = function (imgs) {
              const byIndex = {};
              (imgs || []).forEach(function (im) { byIndex[im.index] = im; });
              // 🔴 **문단 사이에 빈 문단(<p><br></p>)을 넣는다.**
              //    에디터(Quill 기본 CSS)도 웹(site.css 의 `* { margin:0 }`)도 p 에
              //    마진이 없어서 <p>A</p><p>B</p> 로 이으면 줄이 다닥다닥 붙는다.
              //    이 CMS 의 기존 기사는 전부 문단 사이에 <p><br></p> 가 들어 있다 —
              //    **저장 포맷을 기존 기사와 맞추는 것**이 맞다. 웹 CSS 에 p 마진을
              //    주는 방법도 있지만 그러면 기존 9만 건이 두 배로 벌어진다.
              //    (dataToArticle 이 빈 <p></p> 를 <p><br></p> 로 정규화해 왕복해도 유지된다.)
              const blocks = paras.map(function (p) {
                const m = p.trim().match(/^\[\[IMG:(\d+)\]\]$/);
                if (m) {
                  const im = byIndex[Number(m[1])];
                  if (!im) return '';          // 못 받은 사진은 자리표시자째 뺀다
                  return '<p><img src="' + im.url + '"></p><p>' + im.caption + '</p>';
                }
                if (!p.trim()) return '';
                return '<p>' + p.replace(/\n/g, '<br>') + '</p>';
              }).filter(function (b) { return b; });
              return blocks.join('<p><br></p>');
            };
            thisIns.$http.post('/api/wire/importImages', {id: thisIns.$route.query.wire})
              .then(function (r2) {
                thisIns.sendData.text = buildBody((r2.data && r2.data.images) || []);
                thisIns.createDraft(thisIns.$route.query.wire);
              })
              .catch(function () {
                // 사진을 못 가져와도 본문은 넘긴다(자리표시자는 빠진다).
                thisIns.sendData.text = buildBody([]);
                thisIns.createDraft(thisIns.$route.query.wire);
              });
          })
          .catch(function () {
            thisIns.$vs.notify({title:'Error', text:'연합뉴스 기사를 불러오지 못했습니다.',
              color:'danger', iconPack:'feather', icon:'icon-alert-circle'});
            thisIns.createDraft(null);
          });
      }
      else {
        this.sendData.mainTitle = "";
        this.sendData.text = "";
        this.sendData.id = '';
        const thisIns = this;
          // console.log(this.sendData)
        this.$http.post('/api/writeArticles', this.sendData)
          .then(function (response) {
            console.log(response)
            thisIns.autoSaveFlg = false;
            thisIns.$router.push({path: thisIns.$route.path, query: {id: response.data.id}});
            thisIns.$vs.loading.close();
          })
          .catch(function (error) {
            thisIns.$vs.notify({
              title:'Error',
              text: error,
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'})
            thisIns.$vs.loading.close();  
          });
      }
    },
    // 기자리스트 노출 대상인지. '활성(status=A) + 노출 구분값' 두 조건을 모두 본다.
    // status 가 안 실려 오는 옛 응답을 대비해 없으면 활성으로 본다.
    isExposedWriter(w){
      return !w.status || w.status === 'A';
    },
    showSidebar() {
        this.$store.commit('TOGGLE_IS_SIDEBAR_ACTIVE', true);
    },
  },
  computed: {
    activeUserInfo() {
        return this.$store.state.AppActiveUser;
    },
    // 작성자 / 기타 작성자 드롭다운은 member.writer_type('기자리스트 노출')으로 갈린다.
    //   none=미노출  writer=작성자만  other=기타작성자만  both=작성자+기타
    // 부서(option1)·권한(level)과는 무관한 별도 구분값이다. 미노출이어도 기사작성·수정은 된다.
    // this.writer(전체 목록)는 과거 기사의 작성자를 이름으로 되찾는 데 필요하므로 그대로 둔다.
    // ⚠ 예전에 있던 '지정된 사람이 없으면 전체 노출' 폴백은 뺐다. 노출 대상을 명단으로
    //    관리하는 것이 요건이라, 폴백이 남아 있으면 실수로 전원이 드러난다.
    writerOptions() {
      return (this.writer || []).filter(w => this.isExposedWriter(w)
        && (w.writer_type === 'writer' || w.writer_type === 'both'));
    },
    otherWriterOptions() {
      return (this.writer || []).filter(w => this.isExposedWriter(w)
        && (w.writer_type === 'other' || w.writer_type === 'both'));
    },
  },
  created() {
    console.log(this.sendData);
    this.categories1 = this.$store.state.categories1;
    this.categories1_2 = this.$store.state.categories1_2;
    this.categories2 = this.$store.state.categories2;
    this.categories2_2 = this.$store.state.categories2_2;
    this.types = this.$store.state.types;
    this.writer = this.$store.state.writer;
    this.writerList = this.writer.filter(e => moment(e.entry_date) > moment('2001-01-01'));
    this.portals = this.$store.state.portals;
    this.seriesArray = this.$store.state.series;
    this.created();
  },
  beforeDestroy(){
    // 화면을 떠날 때도 남긴다. 서버 저장이 성공했다면 clearDraft 가 기준선을
    // 갱신해 두었으므로 여기서 다시 살아나지 않는다.
    this.saveDraft('destroy');
    if(this.draftTimer) clearInterval(this.draftTimer);
    window.removeEventListener('cms-session-ending', this.sessionEnding);
    if(this.draftBoot) clearTimeout(this.draftBoot);
    if(this.draftOnUnload) window.removeEventListener('beforeunload', this.draftOnUnload);
  },
  mounted(){
    // ── 임시저장 기동 (2026-09-25) ────────────────────────────────
    // 진입 직후 2초 뒤에 기준선을 잡고 복원을 묻는다. 2초는 기존 로드(created 의
    // 기사 조회)가 끝나기를 기다리는 시간이다 — 더 일찍 잡으면 빈 상태가 기준선이 된다.
    this.draftBoot = setTimeout(() => {
      this.draftBaseline = this.draftFingerprint();
      this.initDraft();
    }, 2000);
    // 20초마다, 변경이 있을 때만 저장한다.
    this.draftTimer = setInterval(() => { this.saveDraft('auto'); }, 20000);
    // 창 닫기·새로고침. beforeunload 는 동기라 localStorage 쓰기가 끝난다.
    this.draftOnUnload = () => { this.saveDraft('unload'); };
    window.addEventListener('beforeunload', this.draftOnUnload);
    // 공통 인증 만료 처리 전에 현재 사용자 이름으로 초안을 보존한다.
    this.sessionEnding = () => { this.saveDraft('session-expired'); this.authRedirecting = true; };
    window.addEventListener('cms-session-ending', this.sessionEnding);

    const customSpecialPickerItems = Array.prototype.slice.call(document.querySelectorAll('#toolbar .ql-customSpecial .ql-picker-item'));
    customSpecialPickerItems.forEach(item => item.textContent = item.dataset.value);
    document.querySelector('#toolbar .ql-customSpecial .ql-picker-label').innerHTML
        = '특수문자' + document.querySelector('#toolbar .ql-customSpecial .ql-picker-label').innerHTML;
    const customSpecialPickerItems2 = Array.prototype.slice.call(document.querySelectorAll('#toolbar2 .ql-customSpecial .ql-picker-item'));
    customSpecialPickerItems2.forEach(item => item.textContent = item.dataset.value);
    document.querySelector('#toolbar2 .ql-customSpecial .ql-picker-label').innerHTML
        = '특수문자' + document.querySelector('#toolbar2 .ql-customSpecial .ql-picker-label').innerHTML;
    const customSpecialPickerItems3 = Array.prototype.slice.call(document.querySelectorAll('#toolbar3 .ql-customSpecial .ql-picker-item'));
    customSpecialPickerItems3.forEach(item => item.textContent = item.dataset.value);
    document.querySelector('#toolbar3 .ql-customSpecial .ql-picker-label').innerHTML
        = '특수문자' + document.querySelector('#toolbar3 .ql-customSpecial .ql-picker-label').innerHTML;
    // 특수 블록 버튼 라벨. 퀼 툴바가 버튼 내용을 제 아이콘으로 덮어쓰므로 여기서 되돌린다.
    // 🔴 선택자가 ql-blockquote·ql-code-block·ql-header 였다 — 기본 태그를 빌려 쓰던 시절
    //    잔재다. 이제 전용 포맷이라 클래스도 전용이다.
    [['artSubhead', '내부부제'], ['artSection', '내부단락'],
     ['artBox1', '박스1'], ['artBox2', '박스2'], ['artBubble', '말풍선']].forEach(([fmt, label]) => {
      const el = document.querySelector('#toolbar .ql-' + fmt);
      if (el) el.innerHTML = `<b style="font-size: 16px; line-height: 19px;">${label}</b>`;
    })
    document.querySelector('#toolbar2 .ql-circled').innerHTML
        = `<b style="font-size: 14px; line-height: 19px;">원문자</b>`;
    document.querySelector('#toolbar3 .ql-circled').innerHTML
        = `<b style="font-size: 14px; line-height: 19px;">원문자</b>`;
    document.querySelector('#toolbar .ql-circled').innerHTML
        = `<b style="font-size: 14px; line-height: 19px;">원문자</b>`;
    
    const quill = this.$refs.quillEditor_descr.quill;

    // 붙여넣기 시 <strong class="highlight"> / <b class="highlight"> 보존.
    // 🔴 pasteFilter **보다 먼저** 등록해야 한다. matcher 는 등록 순서대로 도는데,
    //    highlight 를 붙인 뒤에 필터가 돌아야 허용 목록 검사를 통과한다.
    const keepHighlight = (node, delta) => {
      if (node.classList && node.classList.contains('highlight')) {
        delta.ops = delta.ops.map(op => {
          op.attributes = Object.assign({}, op.attributes, { bold: true, highlight: true });
          return op;
        });
      }
      return delta;
    };
    quill.clipboard.addMatcher('STRONG', keepHighlight);
    quill.clipboard.addMatcher('B', keepHighlight);

    // ── 붙여넣기 필터 (2026-09-26) ────────────────────────────────────
    // 워드·한글은 정해진 서식만, 그 밖의 HTML 은 글자만. 상세는 utils/pasteFilter.js.
    // 🔴 에디터 **세 개 모두**에 건다. 제목·부제도 바깥 HTML 이 그대로 들어오던 자리다.
    const notify = (text) => {
      this.$vs.notify({ title: '붙여넣기', text, color: 'primary',
                        iconPack: 'feather', icon: 'icon-clipboard', time: 3000 });
    };
    // 🔴 본문에만 uploadImage 를 준다. 제목·부제는 이미지를 넣을 자리가 아니다.
    installPasteFilter(quill, {
      allow: WORD_ALLOW,
      notify,
      uploadImage: (blob, name) => this.uploadImageToServer(blob, name, { quiet: true }),
    });
    if (this.$refs.quillEditor_b_sbj) {
      installPasteFilter(this.$refs.quillEditor_b_sbj.quill, { allow: TITLE_ALLOW, notify });
    }
    if (this.$refs.quillEditor_s_sbj) {
      installPasteFilter(this.$refs.quillEditor_s_sbj.quill, { allow: TITLE_ALLOW, notify });
    }
    // console.log(document.querySelector('.quillEditor_descr .ql-toolbar'));
    // document.querySelector('.ql-customMacro').innerHTML = '매크로' + document.querySelector('.ql-customMacro').innerHTML;
    // document.querySelector('.ql-customMacro').value = this.sendData.byline;
    
    // 정렬·크기 변경 알림은 이제 모듈 옵션(resize.onChangeSize)으로 받는다.
    // 옛 모듈처럼 전역 리스너를 거는 정적 메서드가 아니다.
    setTimeout(() => { this.timeFlg = true; }, 2000);


  },
}
  </script>

<style lang="scss">
/* 세션 만료 예고 모달 (2026-09-25). CMS 스킨 '판면' 과 같은 값을 쓴다. */
.session-warn {
  position: fixed; inset: 0; z-index: 52000;
  background: rgba(17, 17, 17, .45);
  display: flex; align-items: center; justify-content: center;
}
.session-warn-box {
  width: 380px; max-width: calc(100vw - 40px);
  background: #fff; border: 1px solid #D9D9D9; padding: 26px 28px;
  font-family: 'IBM Plex Sans KR', 'Noto Sans KR', sans-serif;
  h4 { font-family: 'Nanum Myeongjo', serif; font-size: 19px; font-weight: 700;
       margin: 0 0 12px; color: #111; }
  p { margin: 0 0 6px; font-size: 14px; color: #111; }
  b { color: #EA2121; }
}
.session-warn-sub { color: #767676 !important; font-size: 13px !important; margin-top: 10px !important; }
.session-warn-actions { display: flex; gap: 8px; justify-content: flex-end; margin-top: 20px; }

@import "@/assets/scss/custom-style/writeArticles.scss";

.titleTags .vs__search, .titleTags .vs__search:focus{
  width: auto;
}
</style>
